var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndergroundBgTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 229,
    viewBox: "0 0 1080 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1081_118500)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 229,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -571H1080V229H0V-571Z",
    fill: "url(#paint0_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.774 120.81V103.036C120.774 10.5261 193.615 -65.4395 285.695 -69.5958L293.584 -77.6631C193.84 -77.6631 112.888 3.18456 112.888 103.033V120.807H120.777L120.774 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88231 120.81V103.036C6.88231 10.5261 79.7232 -65.4395 171.803 -69.5958L179.692 -77.6631C79.9483 -77.6631 -1.00354 3.18456 -1.00354 103.033V120.807H6.88568L6.88231 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.808 120.81V103.036C220.808 10.5295 293.645 -65.4395 385.729 -69.5958L393.618 -77.6631C293.874 -77.6631 212.922 3.18456 212.922 103.033V120.807H220.811L220.808 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.841 120.81V103.036C320.841 10.5328 393.675 -65.4395 485.762 -69.5958L493.651 -77.6631C393.907 -77.6631 312.955 3.18456 312.955 103.033V120.807H320.845L320.841 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.875 120.81V103.036C420.875 10.5362 493.706 -65.4395 585.796 -69.5958L593.685 -77.6631C493.941 -77.6631 412.99 3.18456 412.99 103.033V120.807H420.879L420.875 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.907 120.81V103.036C520.907 10.5395 593.734 -65.4395 685.828 -69.5958L693.717 -77.6631C593.973 -77.6631 513.021 3.18456 513.021 103.033V120.807H520.91L520.907 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.948 120.81V103.036C620.948 10.5429 693.772 -65.4395 785.869 -69.5958L793.758 -77.6631C694.014 -77.6631 613.062 3.18456 613.062 103.033V120.807H620.951L620.948 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.981 120.81V103.036C720.981 10.5463 793.801 -65.4395 885.901 -69.5958L893.791 -77.6631C794.047 -77.6631 713.095 3.18456 713.095 103.033V120.807H720.984L720.981 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.015 120.81V103.036C821.015 10.5496 893.832 -65.4395 985.936 -69.5958L993.825 -77.6631C894.081 -77.6631 813.129 3.18456 813.129 103.033V120.807H821.018L821.015 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.049 120.81V103.036C925.049 10.5496 997.867 -65.4395 1089.97 -69.5958L1097.86 -77.6631C998.115 -77.6631 917.164 3.18456 917.164 103.033V120.807H925.053L925.049 120.81Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.18 120.812V102.224C1028.18 44.0263 1057.02 -7.63995 1101.35 -38.9851V-48.5342C1052.51 -16.1944 1020.3 39.235 1020.3 102.224V120.812H1028.19H1028.18Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.84 118.309H92.3728V121.124H993.84V118.309Z",
    fill: "#BEAEAE",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.41 176.999H-9.07678V186.535H1100.41V176.999Z",
    fill: "#B3B0A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.62 181.352H-9.07678V184.507H1106.62V181.352Z",
    fill: "#F7F6F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.78765 230.466V227.89H1095.45V230.466H-8.78765Z",
    fill: "#F7F6F1",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.79 194.874H-9.07678V221.311H1102.79V194.874Z",
    fill: "#B3E0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.78765 169.568V146.01H1095.45V169.568H-8.78765Z",
    fill: "#C49B9B",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.78765 155.475V104.212H1095.45V155.475H-8.78765Z",
    fill: "#B2A3A3",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.78704 155.146V103.883H1095.45V155.146H-8.78704Z",
    fill: "#B2A3A3",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.612 120.12H100.89V132.522H126.612V120.12Z",
    fill: "#B1CEDB",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.598 121.159H106.856V131.489H130.598V121.159Z",
    fill: "#F7F6F1",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.562 122.193V130.45H107.893V122.193H129.562ZM131.632 120.12H105.817V132.522H131.632V120.12Z",
    fill: "#B1CEDB",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.317 20.6699H83.8873C82.7836 20.6699 81.8888 21.5647 81.8888 22.6685V116.761C81.8888 117.865 82.7836 118.76 83.8873 118.76H144.317C145.42 118.76 146.315 117.865 146.315 116.761V22.6685C146.315 21.5647 145.42 20.6699 144.317 20.6699Z",
    fill: "#4D8DE1",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.836 21.9639H89.7524C89.3634 21.9639 89.0481 22.2792 89.0481 22.6681V116.761C89.0481 117.15 89.3634 117.465 89.7524 117.465H149.836C150.225 117.465 150.54 117.15 150.54 116.761V22.6681C150.54 22.2792 150.225 21.9639 149.836 21.9639Z",
    fill: "#F7F6F1",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.246 23.2585V116.171H90.3427V23.2585H149.246ZM149.836 20.6699H89.7497C88.6469 20.6699 87.7511 21.5657 87.7511 22.6685V116.761C87.7511 117.864 88.6469 118.76 89.7497 118.76H149.836C150.939 118.76 151.835 117.864 151.835 116.761V22.6685C151.835 21.5657 150.939 20.6699 149.836 20.6699Z",
    fill: "#9EADC0",
    stroke: "black",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.208 108.301C131.059 108.301 130.908 108.245 130.791 108.134C130.544 107.902 130.531 107.516 130.763 107.272L136.181 101.499L127.742 92.5068H122.71C122.373 92.5068 122.098 92.2349 122.098 91.8951V83.6415H116.838C116.501 83.6415 116.226 83.3696 116.226 83.0299V77.3678C116.226 77.2133 116.285 77.062 116.393 76.9508L119.569 73.5653V67.7086L116.304 64.2305C116.199 64.1162 116.137 63.9679 116.137 63.8135V51.4515C116.137 51.1148 116.409 50.8398 116.748 50.8398C117.088 50.8398 117.36 51.1117 117.36 51.4515V63.5725L120.625 67.0507C120.73 67.165 120.792 67.3132 120.792 67.4677V73.8093C120.792 73.9638 120.733 74.1151 120.625 74.2263L117.45 77.6118V82.4213H122.71C123.047 82.4213 123.322 82.6932 123.322 83.0329V91.2866H128.008C128.177 91.2866 128.338 91.3577 128.452 91.4781L137.463 101.079C137.682 101.313 137.682 101.678 137.463 101.913L131.653 108.106C131.532 108.233 131.371 108.298 131.208 108.298V108.301Z",
    fill: "#CC346F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4933 87.0759C95.1566 87.0759 94.8817 86.804 94.8817 86.4643V83.5019C94.8817 83.1653 95.1535 82.8903 95.4933 82.8903H105.77V81.6331C105.77 81.2964 106.042 81.0215 106.382 81.0215H111.927V77.0676C111.927 76.9132 111.985 76.7618 112.093 76.6506L115.133 73.4103C115.247 73.2868 115.411 73.2188 115.578 73.2188H123.773V68.6132C123.773 68.4587 123.831 68.3074 123.94 68.1962L132.054 59.5502C132.168 59.4266 132.329 59.3587 132.499 59.3587H137.704V53.8851C137.704 53.5484 137.976 53.2734 138.316 53.2734C138.655 53.2734 138.927 53.5453 138.927 53.8851V59.9703C138.927 60.307 138.655 60.5819 138.316 60.5819H132.765L124.996 68.8603V73.8335C124.996 74.1702 124.724 74.4451 124.384 74.4451H115.843L113.15 77.3148V81.6393C113.15 81.976 112.878 82.2509 112.538 82.2509H106.994V83.5081C106.994 83.8448 106.722 84.1197 106.382 84.1197H96.1049V86.4704C96.1049 86.8071 95.8331 87.0821 95.4933 87.0821V87.0759Z",
    fill: "#01666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.462 88.548C132.443 88.548 132.422 88.548 132.403 88.548C132.215 88.5295 132.045 88.4244 131.946 88.2669L127.819 81.706C127.757 81.6102 127.726 81.499 127.726 81.3847L127.698 77.6286H103.061C102.891 77.6286 102.73 77.5575 102.616 77.437L99.0453 73.6314C98.826 73.3967 98.826 73.0322 99.0453 72.7974L103.441 68.1146L100.494 64.9731C100.262 64.726 100.275 64.3399 100.522 64.1113C100.769 63.8796 101.155 63.892 101.384 64.1391L104.723 67.6976C104.942 67.9323 104.942 68.2968 104.723 68.5316L100.327 73.2144L103.327 76.4084H128.304C128.641 76.4084 128.912 76.6802 128.916 77.0138L128.946 81.1994L132.561 86.9448L137.212 81.9902C137.327 81.8666 137.487 81.7986 137.657 81.7986C137.827 81.7986 137.988 81.8697 138.102 81.9932L141.636 85.7957C141.864 86.0429 141.852 86.429 141.605 86.6576C141.358 86.8861 140.972 86.8738 140.743 86.6267L137.654 83.303L132.91 88.3596C132.792 88.4831 132.632 88.5511 132.465 88.5511L132.462 88.548Z",
    fill: "#494291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.55 91.2945H113.039C112.869 91.2945 112.708 91.2234 112.594 91.103L109.764 88.0882C109.659 87.9739 109.597 87.8256 109.597 87.6711V54.8294C109.597 54.4927 109.869 54.2178 110.209 54.2178C110.549 54.2178 110.821 54.4896 110.821 54.8294V87.4302L113.304 90.0775H119.287L142.575 65.267C142.807 65.0198 143.193 65.0075 143.437 65.2392C143.684 65.4708 143.696 65.857 143.465 66.101L119.995 91.1061C119.881 91.2296 119.717 91.2976 119.55 91.2976V91.2945Z",
    fill: "#FDD247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.009 110.032H101.031C100.695 110.032 100.42 109.76 100.42 109.421C100.42 109.081 100.691 108.809 101.031 108.809H118.743L125.477 101.636H116.841C116.504 101.636 116.229 101.365 116.229 101.025V84.5328L106.891 94.124C106.777 94.2414 106.619 94.3093 106.452 94.3093H97.4048C97.0681 94.3093 96.7932 94.0375 96.7932 93.6977C96.7932 93.3579 97.065 93.0861 97.4048 93.0861H106.196L116.402 82.6053C116.575 82.4261 116.837 82.3705 117.069 82.4663C117.298 82.5589 117.449 82.7844 117.449 83.0316V100.416H126.886C127.13 100.416 127.349 100.561 127.445 100.784C127.541 101.006 127.497 101.266 127.331 101.445L119.451 109.841C119.336 109.964 119.176 110.032 119.006 110.032H119.009Z",
    fill: "#4384B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.391 67.4713C119.391 67.0078 119.743 66.6309 120.179 66.6309C120.615 66.6309 120.967 67.0078 120.967 67.4713C120.967 67.9347 120.615 68.3116 120.179 68.3116C119.743 68.3116 119.391 67.9347 119.391 67.4713Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.964 63.7086C115.964 63.2451 116.316 62.8682 116.752 62.8682C117.188 62.8682 117.54 63.2451 117.54 63.7086C117.54 64.172 117.188 64.5489 116.752 64.5489C116.316 64.5489 115.964 64.172 115.964 63.7086Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.964 55.9898C115.964 55.5264 116.316 55.1494 116.752 55.1494C117.187 55.1494 117.54 55.5264 117.54 55.9898C117.54 56.4533 117.187 56.8302 116.752 56.8302C116.316 56.8302 115.964 56.4533 115.964 55.9898Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.964 51.4546C115.964 50.9912 116.316 50.6143 116.752 50.6143C117.187 50.6143 117.54 50.9912 117.54 51.4546C117.54 51.9181 117.187 52.295 116.752 52.295C116.316 52.295 115.964 51.9181 115.964 51.4546Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.391 73.8609C119.391 73.3974 119.743 73.0205 120.179 73.0205C120.615 73.0205 120.967 73.3974 120.967 73.8609C120.967 74.3243 120.615 74.7013 120.179 74.7013C119.743 74.7013 119.391 74.3243 119.391 73.8609Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.476 73.8609C123.476 73.3974 123.828 73.0205 124.264 73.0205C124.699 73.0205 125.052 73.3974 125.052 73.8609C125.052 74.3243 124.699 74.7013 124.264 74.7013C123.828 74.7013 123.476 74.3243 123.476 73.8609Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.593 68.6167C123.593 68.1533 123.945 67.7764 124.381 67.7764C124.816 67.7764 125.169 68.1533 125.169 68.6167C125.169 69.0802 124.816 69.4571 124.381 69.4571C123.945 69.4571 123.593 69.0802 123.593 68.6167Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.933 63.9947C127.933 63.5312 128.285 63.1543 128.721 63.1543C129.157 63.1543 129.509 63.5312 129.509 63.9947C129.509 64.4581 129.157 64.8351 128.721 64.8351C128.285 64.8351 127.933 64.4581 127.933 63.9947Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71 60.023C131.71 59.5596 132.062 59.1826 132.498 59.1826C132.933 59.1826 133.285 59.5596 133.285 60.023C133.285 60.4865 132.933 60.8634 132.498 60.8634C132.062 60.8634 131.71 60.4865 131.71 60.023Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.523 60.023C137.523 59.5596 137.875 59.1826 138.311 59.1826C138.746 59.1826 139.099 59.5596 139.099 60.023C139.099 60.4865 138.746 60.8634 138.311 60.8634C137.875 60.8634 137.523 60.4865 137.523 60.023Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.226 65.6724C142.226 65.209 142.579 64.832 143.014 64.832C143.45 64.832 143.802 65.209 143.802 65.6724C143.802 66.1359 143.45 66.5128 143.014 66.5128C142.579 66.5128 142.226 66.1359 142.226 65.6724Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.314 69.7359C138.314 69.2724 138.666 68.8955 139.102 68.8955C139.538 68.8955 139.89 69.2724 139.89 69.7359C139.89 70.1993 139.538 70.5763 139.102 70.5763C138.666 70.5763 138.314 70.1993 138.314 69.7359Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.764 75.7935C132.764 75.3301 133.116 74.9531 133.552 74.9531C133.987 74.9531 134.339 75.3301 134.339 75.7935C134.339 76.257 133.987 76.6339 133.552 76.6339C133.116 76.6339 132.764 76.257 132.764 75.7935Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.546 81.3775C127.546 80.914 127.898 80.5371 128.334 80.5371C128.769 80.5371 129.121 80.914 129.121 81.3775C129.121 81.8409 128.769 82.2179 128.334 82.2179C127.898 82.2179 127.546 81.8409 127.546 81.3775Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.546 77.0289C127.546 76.5654 127.898 76.1885 128.334 76.1885C128.769 76.1885 129.121 76.5654 129.121 77.0289C129.121 77.4923 128.769 77.8693 128.334 77.8693C127.898 77.8693 127.546 77.4923 127.546 77.0289Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.115 77.148C116.115 76.6845 116.467 76.3076 116.903 76.3076C117.338 76.3076 117.69 76.6845 117.69 77.148C117.69 77.6114 117.338 77.9884 116.903 77.9884C116.467 77.9884 116.115 77.6114 116.115 77.148Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.789 73.8609C114.789 73.3974 115.141 73.0205 115.577 73.0205C116.012 73.0205 116.365 73.3974 116.365 73.8609C116.365 74.3243 116.012 74.7013 115.577 74.7013C115.141 74.7013 114.789 74.3243 114.789 73.8609Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.883 77.0289C111.883 76.5654 112.236 76.1885 112.671 76.1885C113.107 76.1885 113.459 76.5654 113.459 77.0289C113.459 77.4923 113.107 77.8693 112.671 77.8693C112.236 77.8693 111.883 77.4923 111.883 77.0289Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.417 81.6119C109.417 81.1484 109.77 80.7715 110.205 80.7715C110.641 80.7715 110.993 81.1484 110.993 81.6119C110.993 82.0753 110.641 82.4523 110.205 82.4523C109.77 82.4523 109.417 82.0753 109.417 81.6119Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.232 84.2745C106.668 84.2745 107.02 83.8983 107.02 83.4342C107.02 82.97 106.668 82.5938 106.232 82.5938C105.797 82.5938 105.445 82.97 105.445 83.4342C105.445 83.8983 105.797 84.2745 106.232 84.2745Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.469 88.7183C110.469 88.2549 110.821 87.8779 111.257 87.8779C111.692 87.8779 112.045 88.2549 112.045 88.7183C112.045 89.1818 111.692 89.5587 111.257 89.5587C110.821 89.5587 110.469 89.1818 110.469 88.7183Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.115 83.0357C116.115 82.5722 116.467 82.1953 116.903 82.1953C117.338 82.1953 117.69 82.5722 117.69 83.0357C117.69 83.4991 117.338 83.8761 116.903 83.8761C116.467 83.8761 116.115 83.4991 116.115 83.0357Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.851 83.0357C121.851 82.5722 122.203 82.1953 122.639 82.1953C123.075 82.1953 123.427 82.5722 123.427 83.0357C123.427 83.4991 123.075 83.8761 122.639 83.8761C122.203 83.8761 121.851 83.4991 121.851 83.0357Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.115 90.6832C116.115 90.2197 116.467 89.8428 116.903 89.8428C117.338 89.8428 117.69 90.2197 117.69 90.6832C117.69 91.1466 117.338 91.5236 116.903 91.5236C116.467 91.5236 116.115 91.1466 116.115 90.6832Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.964 100.972C115.964 100.509 116.316 100.132 116.752 100.132C117.188 100.132 117.54 100.509 117.54 100.972C117.54 101.436 117.188 101.813 116.752 101.813C116.316 101.813 115.964 101.436 115.964 100.972Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.964 95.5503C115.964 95.0869 116.316 94.71 116.752 94.71C117.187 94.71 117.54 95.0869 117.54 95.5503C117.54 96.0138 117.187 96.3907 116.752 96.3907C116.316 96.3907 115.964 96.0138 115.964 95.5503Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.097 100.972C126.097 100.509 126.449 100.132 126.885 100.132C127.321 100.132 127.673 100.509 127.673 100.972C127.673 101.436 127.321 101.813 126.885 101.813C126.449 101.813 126.097 101.436 126.097 100.972Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.923 91.899C121.923 91.4355 122.275 91.0586 122.711 91.0586C123.146 91.0586 123.498 91.4355 123.498 91.899C123.498 92.3624 123.146 92.7394 122.711 92.7394C122.275 92.7394 121.923 92.3624 121.923 91.899Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.546 91.899C127.546 91.4355 127.898 91.0586 128.334 91.0586C128.769 91.0586 129.121 91.4355 129.121 91.899C129.121 92.3624 128.769 92.7394 128.334 92.7394C127.898 92.7394 127.546 92.3624 127.546 91.899Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71 96.6675C131.71 96.2041 132.062 95.8271 132.498 95.8271C132.933 95.8271 133.286 96.2041 133.286 96.6675C133.286 97.131 132.933 97.5079 132.498 97.5079C132.062 97.5079 131.71 97.131 131.71 96.6675Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.461 88.7775C132.896 88.7775 133.249 88.4012 133.249 87.9371C133.249 87.4729 132.896 87.0967 132.461 87.0967C132.026 87.0967 131.673 87.4729 131.673 87.9371C131.673 88.4012 132.026 88.7775 132.461 88.7775Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.906 82.4742C136.906 82.0107 137.258 81.6338 137.694 81.6338C138.13 81.6338 138.482 82.0107 138.482 82.4742C138.482 82.9376 138.13 83.3146 137.694 83.3146C137.258 83.3146 136.906 82.9376 136.906 82.4742Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4 86.2056C140.4 85.7422 140.752 85.3652 141.188 85.3652C141.623 85.3652 141.975 85.7422 141.975 86.2056C141.975 86.6691 141.623 87.046 141.188 87.046C140.752 87.046 140.4 86.6691 140.4 86.2056Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.231 101.533C136.231 101.069 136.583 100.692 137.019 100.692C137.454 100.692 137.807 101.069 137.807 101.533C137.807 101.996 137.454 102.373 137.019 102.373C136.583 102.373 136.231 101.996 136.231 101.533Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.383 107.693C130.383 107.229 130.736 106.853 131.171 106.853C131.607 106.853 131.959 107.229 131.959 107.693C131.959 108.156 131.607 108.533 131.171 108.533C130.736 108.533 130.383 108.156 130.383 107.693Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.987 110.261C119.422 110.261 119.775 109.885 119.775 109.42C119.775 108.956 119.422 108.58 118.987 108.58C118.552 108.58 118.199 108.956 118.199 109.42C118.199 109.885 118.552 110.261 118.987 110.261Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.701 109.42C109.701 108.957 110.054 108.58 110.489 108.58C110.925 108.58 111.277 108.957 111.277 109.42C111.277 109.884 110.925 110.261 110.489 110.261C110.054 110.261 109.701 109.884 109.701 109.42Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.889 110.261C101.324 110.261 101.677 109.885 101.677 109.42C101.677 108.956 101.324 108.58 100.889 108.58C100.454 108.58 100.101 108.956 100.101 109.42C100.101 109.885 100.454 110.261 100.889 110.261Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 90.6832C118.725 90.2197 119.077 89.8428 119.513 89.8428C119.948 89.8428 120.301 90.2197 120.301 90.6832C120.301 91.1466 119.948 91.5236 119.513 91.5236C119.077 91.5236 118.725 91.1466 118.725 90.6832Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.251 90.6832C112.251 90.2197 112.603 89.8428 113.039 89.8428C113.474 89.8428 113.827 90.2197 113.827 90.6832C113.827 91.1466 113.474 91.5236 113.039 91.5236C112.603 91.5236 112.251 91.1466 112.251 90.6832Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.642 88.1544C123.077 88.1544 123.43 87.7782 123.43 87.314C123.43 86.8499 123.077 86.4736 122.642 86.4736C122.207 86.4736 121.854 86.8499 121.854 87.314C121.854 87.7782 122.207 88.1544 122.642 88.1544Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.445 93.7203C105.445 93.2568 105.797 92.8799 106.232 92.8799C106.668 92.8799 107.02 93.2568 107.02 93.7203C107.02 94.1837 106.668 94.5607 106.232 94.5607C105.797 94.5607 105.445 94.1837 105.445 93.7203Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.618 93.7203C96.618 93.2568 96.9703 92.8799 97.4059 92.8799C97.8416 92.8799 98.1938 93.2568 98.1938 93.7203C98.1938 94.1837 97.8416 94.5607 97.4059 94.5607C96.9703 94.5607 96.618 94.1837 96.618 93.7203Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3347 83.523C97.3347 83.0595 97.6869 82.6826 98.1226 82.6826C98.5582 82.6826 98.9104 83.0595 98.9104 83.523C98.9104 83.9864 98.5582 84.3634 98.1226 84.3634C97.6869 84.3634 97.3347 83.9864 97.3347 83.523Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7048 86.4644C94.7048 86.001 95.0571 85.624 95.4927 85.624C95.9283 85.624 96.2806 86.001 96.2806 86.4644C96.2806 86.9279 95.9283 87.3048 95.4927 87.3048C95.0571 87.3048 94.7048 86.9279 94.7048 86.4644Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.417 76.9722C109.417 76.5088 109.77 76.1318 110.205 76.1318C110.641 76.1318 110.993 76.5088 110.993 76.9722C110.993 77.4357 110.641 77.8126 110.205 77.8126C109.77 77.8126 109.417 77.4357 109.417 76.9722Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.272 77.0152C102.272 76.5517 102.624 76.1748 103.06 76.1748C103.496 76.1748 103.848 76.5517 103.848 77.0152C103.848 77.4786 103.496 77.8556 103.06 77.8556C102.624 77.8556 102.272 77.4786 102.272 77.0152Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7014 73.1949C98.7014 72.7314 99.0536 72.3545 99.4893 72.3545C99.9249 72.3545 100.277 72.7314 100.277 73.1949C100.277 73.6583 99.9249 74.0353 99.4893 74.0353C99.0536 74.0353 98.7014 73.6583 98.7014 73.1949Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.409 68.1002C103.409 67.6367 103.762 67.2598 104.197 67.2598C104.633 67.2598 104.985 67.6367 104.985 68.1002C104.985 68.5636 104.633 68.9405 104.197 68.9405C103.762 68.9405 103.409 68.5636 103.409 68.1002Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.172 64.5513C100.172 64.0879 100.525 63.7109 100.96 63.7109C101.396 63.7109 101.748 64.0879 101.748 64.5513C101.748 65.0148 101.396 65.3917 100.96 65.3917C100.525 65.3917 100.172 65.0148 100.172 64.5513Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.417 70.857C109.417 70.3935 109.77 70.0166 110.205 70.0166C110.641 70.0166 110.993 70.3935 110.993 70.857C110.993 71.3204 110.641 71.6974 110.205 71.6974C109.77 71.6974 109.417 71.3204 109.417 70.857Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.417 61.1402C109.417 60.6767 109.77 60.2998 110.205 60.2998C110.641 60.2998 110.993 60.6767 110.993 61.1402C110.993 61.6036 110.641 61.9806 110.205 61.9806C109.77 61.9806 109.417 61.6036 109.417 61.1402Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.205 55.6652C110.64 55.6652 110.993 55.2889 110.993 54.8248C110.993 54.3606 110.64 53.9844 110.205 53.9844C109.77 53.9844 109.417 54.3606 109.417 54.8248C109.417 55.2889 109.77 55.6652 110.205 55.6652Z",
    fill: "#222B54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.523 53.8843C137.523 53.4209 137.875 53.0439 138.311 53.0439C138.746 53.0439 139.099 53.4209 139.099 53.8843C139.099 54.3478 138.746 54.7247 138.311 54.7247C137.875 54.7247 137.523 54.3478 137.523 53.8843Z",
    fill: "#222B54"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M136.921 27.2881H102.668V34.3433H136.921V27.2881Z",
    fill: "#6AB5CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M140.739 37.3174H98.8466V44.3726H140.739V37.3174Z",
    fill: "#6AB5CF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1081_118500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.215 174.459H1311.72V181.47H731.215V174.459Z",
    fill: "#958A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.652 102.732H756.285V102.735C748.7 102.735 732.44 135.027 730.42 168.126C730.405 168.251 730.391 168.375 730.376 168.5C730.369 169.087 730.382 169.667 730.412 170.234C730.52 174.668 731.111 178.313 731.111 178.313H769.652V178.241H1311.99V102.865H771.846C771.13 102.865 770.397 102.936 769.652 103.075V102.732Z",
    fill: "white",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.58 173.627L728.793 173.478C728.099 175.534 729.37 181.721 729.37 181.721H858.626V181.721H1311.86V173.627H858.58Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.793 173.478L728.519 173.385L728.586 173.188L728.794 173.188L728.793 173.478ZM858.58 173.627V173.916L858.58 173.916L858.58 173.627ZM729.37 181.721V182.011H729.134L729.086 181.78L729.37 181.721ZM858.626 181.721H858.915V182.011H858.626V181.721ZM858.626 181.721H858.337V181.432H858.626V181.721ZM1311.86 181.721H1312.15V182.01H1311.86V181.721ZM1311.86 173.627V173.338H1312.15V173.627H1311.86ZM728.794 173.188L858.581 173.338L858.58 173.916L728.793 173.767L728.794 173.188ZM729.37 181.721C729.086 181.78 729.086 181.78 729.086 181.779C729.086 181.779 729.086 181.779 729.086 181.779C729.086 181.779 729.086 181.779 729.086 181.778C729.086 181.777 729.086 181.776 729.085 181.775C729.085 181.772 729.084 181.767 729.083 181.761C729.08 181.749 729.076 181.731 729.072 181.708C729.063 181.662 729.049 181.593 729.032 181.506C728.999 181.332 728.952 181.081 728.897 180.773C728.788 180.158 728.65 179.315 728.534 178.407C728.418 177.501 728.323 176.524 728.301 175.641C728.28 174.767 728.328 173.951 728.519 173.385L729.067 173.57C728.911 174.033 728.858 174.761 728.879 175.626C728.9 176.482 728.993 177.437 729.108 178.334C729.222 179.23 729.359 180.063 729.466 180.672C729.52 180.977 729.567 181.225 729.6 181.397C729.617 181.483 729.63 181.55 729.639 181.595C729.643 181.617 729.647 181.635 729.649 181.646C729.65 181.652 729.651 181.656 729.652 181.659C729.652 181.661 729.652 181.662 729.653 181.662C729.653 181.663 729.653 181.663 729.653 181.663C729.653 181.663 729.653 181.663 729.653 181.663C729.653 181.663 729.653 181.663 729.37 181.721ZM858.626 182.011H729.37V181.432H858.626V182.011ZM858.915 181.721V181.721H858.337V181.721H858.915ZM1311.86 182.01H858.626V181.432H1311.86V182.01ZM1312.15 173.627V181.721H1311.57V173.627H1312.15ZM858.58 173.338H1311.86V173.916H858.58V173.338Z",
    fill: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.767 165.263C801.134 165.263 801.431 164.966 801.431 164.599V145.17C801.431 144.802 801.134 144.506 800.767 144.506C800.399 144.506 800.102 144.802 800.102 145.17V164.599C800.102 164.966 800.399 165.263 800.767 165.263Z",
    fill: "#D9D9D9",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.981 165.263C771.349 165.263 771.646 164.966 771.646 164.599V145.17C771.646 144.802 771.349 144.506 770.981 144.506C770.614 144.506 770.317 144.802 770.317 145.17V164.599C770.317 164.966 770.614 165.263 770.981 165.263Z",
    fill: "#D9D9D9",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.397 102.808H1312.56V97.4795H1298.67H779.214C763.928 97.4795 754.127 101.572 752.397 102.808Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.72 104.598V101.441L766.417 101.087C766.417 101.087 759.287 100.933 753.594 102.77C741.522 108.191 727.065 156.919 727.065 171.457C727.065 173.999 729.164 173.862 730.671 173.862H1311.99V170.673H732.482C734.468 157.2 748.858 105.596 758.824 105.596L1311.72 104.598Z",
    fill: "#F8C8C4",
    stroke: "#9A9797",
    strokeWidth: 0.494328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.763 168.674C772.763 169.778 773.658 170.673 774.761 170.672L796.659 170.671C797.763 170.671 798.657 169.776 798.657 168.672V112.075C798.657 110.971 797.762 110.076 796.659 110.076L774.761 110.076C773.657 110.076 772.763 110.971 772.763 112.075V168.674Z",
    fill: "white",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.016 115.152H792.193C793.347 115.152 794.282 116.088 794.282 117.241V145.487C794.282 146.64 793.347 147.576 792.193 147.576H779.016C777.862 147.576 776.927 146.64 776.927 145.487V117.241C776.927 116.088 777.862 115.152 779.016 115.152Z",
    fill: "#9A9EB2",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.016 115.152H792.193C793.347 115.152 794.282 116.088 794.282 117.241V145.487C794.282 146.64 793.347 147.576 792.193 147.576H779.016C777.862 147.576 776.927 146.64 776.927 145.487V117.241C776.927 116.088 777.862 115.152 779.016 115.152Z",
    fill: "#9A9EB2",
    stroke: "#232222",
    strokeWidth: 0.289133,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.025 115.837H791.128C792.282 115.837 793.217 116.772 793.217 117.926V144.767C793.217 145.92 792.282 146.856 791.128 146.856H780.025C778.871 146.856 777.936 145.92 777.936 144.767V117.926C777.936 116.772 778.871 115.837 780.025 115.837Z",
    fill: "url(#paint1_linear_1081_118500)",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M815.485 109.979C815.485 109.614 815.799 109.317 816.186 109.317H840.804C841.191 109.317 841.505 109.614 841.505 109.979V173.155C841.505 173.52 841.191 173.817 840.804 173.817H816.186C815.799 173.817 815.485 173.52 815.485 173.155V109.979ZM821.448 115.61C821.448 115.245 821.762 114.948 822.149 114.948H836.939C837.326 114.948 837.64 115.245 837.64 115.61V168.373C837.64 168.738 837.326 169.035 836.939 169.035H826.186C825.904 169.035 825.65 168.876 825.54 168.631L821.504 159.625C821.467 159.543 821.448 159.456 821.448 159.367V115.61Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.64 115.61C837.64 115.245 837.326 114.948 836.939 114.948H822.149C821.762 114.948 821.448 115.245 821.448 115.61V159.367C821.448 159.456 821.467 159.543 821.504 159.625L825.54 168.631C825.65 168.876 825.904 169.035 826.186 169.035H836.939C837.326 169.035 837.64 168.738 837.64 168.373V115.61Z",
    fill: "url(#paint2_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.64 115.61C837.64 115.245 837.326 114.948 836.939 114.948H822.149C821.762 114.948 821.448 115.245 821.448 115.61V159.367C821.448 159.456 821.467 159.543 821.504 159.625L825.54 168.631C825.65 168.876 825.904 169.035 826.186 169.035H836.939C837.326 169.035 837.64 168.738 837.64 168.373V115.61Z",
    fill: "url(#paint3_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M867.525 109.979C867.525 109.614 867.211 109.317 866.824 109.317H842.206C841.819 109.317 841.505 109.614 841.505 109.979V173.155C841.505 173.52 841.819 173.817 842.206 173.817H866.824C867.211 173.817 867.525 173.52 867.525 173.155V109.979ZM861.562 115.61C861.562 115.245 861.248 114.948 860.861 114.948H846.072C845.684 114.948 845.371 115.245 845.371 115.61V168.373C845.371 168.738 845.684 169.035 846.072 169.035H856.824C857.106 169.035 857.36 168.876 857.47 168.631L861.507 159.625C861.543 159.543 861.562 159.456 861.562 159.367V115.61Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.371 115.61C845.371 115.245 845.684 114.948 846.072 114.948H860.861C861.248 114.948 861.562 115.245 861.562 115.61V159.367C861.562 159.456 861.543 159.543 861.507 159.625L857.47 168.631C857.36 168.876 857.106 169.035 856.824 169.035H846.072C845.684 169.035 845.371 168.738 845.371 168.373V115.61Z",
    fill: "url(#paint4_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.505 173.155V109.979M841.505 173.155C841.505 173.52 841.191 173.817 840.804 173.817H816.186C815.799 173.817 815.485 173.52 815.485 173.155V109.979C815.485 109.614 815.799 109.317 816.186 109.317H840.804C841.191 109.317 841.505 109.614 841.505 109.979M841.505 173.155C841.505 173.52 841.819 173.817 842.206 173.817H866.824C867.211 173.817 867.525 173.52 867.525 173.155V109.979C867.525 109.614 867.211 109.317 866.824 109.317H842.206C841.819 109.317 841.505 109.614 841.505 109.979M821.448 159.367V115.61C821.448 115.245 821.762 114.948 822.149 114.948H836.939C837.326 114.948 837.64 115.245 837.64 115.61V168.373C837.64 168.738 837.326 169.035 836.939 169.035H826.186C825.904 169.035 825.65 168.876 825.54 168.631L821.504 159.625C821.467 159.543 821.448 159.456 821.448 159.367ZM861.562 159.367V115.61C861.562 115.245 861.248 114.948 860.861 114.948H846.072C845.684 114.948 845.371 115.245 845.371 115.61V168.373C845.371 168.738 845.684 169.035 846.072 169.035H856.824C857.106 169.035 857.36 168.876 857.47 168.631L861.507 159.625C861.543 159.543 861.562 159.456 861.562 159.367Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 838.762,
    y: 113.688,
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 842.687,
    y: 113.688,
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.692 109.979C948.692 109.614 949.006 109.317 949.393 109.317H974.011C974.398 109.317 974.712 109.614 974.712 109.979V173.155C974.712 173.52 974.398 173.817 974.011 173.817H949.393C949.006 173.817 948.692 173.52 948.692 173.155V109.979ZM954.655 115.61C954.655 115.245 954.969 114.948 955.356 114.948H970.145C970.533 114.948 970.847 115.245 970.847 115.61V168.373C970.847 168.738 970.533 169.035 970.145 169.035H959.393C959.111 169.035 958.857 168.876 958.747 168.631L954.71 159.625C954.674 159.543 954.655 159.456 954.655 159.367V115.61Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.847 115.61C970.847 115.245 970.533 114.948 970.145 114.948H955.356C954.969 114.948 954.655 115.245 954.655 115.61V159.367C954.655 159.456 954.674 159.543 954.71 159.625L958.747 168.631C958.857 168.876 959.111 169.035 959.393 169.035H970.145C970.533 169.035 970.847 168.738 970.847 168.373V115.61Z",
    fill: "url(#paint5_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.847 115.61C970.847 115.245 970.533 114.948 970.145 114.948H955.356C954.969 114.948 954.655 115.245 954.655 115.61V159.367C954.655 159.456 954.674 159.543 954.71 159.625L958.747 168.631C958.857 168.876 959.111 169.035 959.393 169.035H970.145C970.533 169.035 970.847 168.738 970.847 168.373V115.61Z",
    fill: "url(#paint6_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1000.73 109.979C1000.73 109.614 1000.42 109.317 1000.03 109.317H975.413C975.026 109.317 974.712 109.614 974.712 109.979V173.155C974.712 173.52 975.026 173.817 975.413 173.817H1000.03C1000.42 173.817 1000.73 173.52 1000.73 173.155V109.979ZM994.769 115.61C994.769 115.245 994.455 114.948 994.068 114.948H979.278C978.891 114.948 978.577 115.245 978.577 115.61V168.373C978.577 168.738 978.891 169.035 979.278 169.035H990.031C990.313 169.035 990.567 168.876 990.677 168.631L994.713 159.625C994.75 159.543 994.769 159.456 994.769 159.367V115.61Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.577 115.61C978.577 115.245 978.891 114.948 979.278 114.948H994.068C994.455 114.948 994.769 115.245 994.769 115.61V159.367C994.769 159.456 994.75 159.543 994.713 159.625L990.677 168.631C990.567 168.876 990.313 169.035 990.031 169.035H979.278C978.891 169.035 978.577 168.738 978.577 168.373V115.61Z",
    fill: "url(#paint7_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.712 173.155V109.979M974.712 173.155C974.712 173.52 974.398 173.817 974.011 173.817H949.393C949.006 173.817 948.692 173.52 948.692 173.155V109.979C948.692 109.614 949.006 109.317 949.393 109.317H974.011C974.398 109.317 974.712 109.614 974.712 109.979M974.712 173.155C974.712 173.52 975.026 173.817 975.413 173.817H1000.03C1000.42 173.817 1000.73 173.52 1000.73 173.155V109.979C1000.73 109.614 1000.42 109.317 1000.03 109.317H975.413C975.026 109.317 974.712 109.614 974.712 109.979M954.655 159.367V115.61C954.655 115.245 954.969 114.948 955.356 114.948H970.145C970.533 114.948 970.847 115.245 970.847 115.61V168.373C970.847 168.738 970.533 169.035 970.145 169.035H959.393C959.111 169.035 958.857 168.876 958.747 168.631L954.71 159.625C954.674 159.543 954.655 159.456 954.655 159.367ZM994.769 159.367V115.61C994.769 115.245 994.455 114.948 994.068 114.948H979.278C978.891 114.948 978.577 115.245 978.577 115.61V168.373C978.577 168.738 978.891 169.035 979.278 169.035H990.031C990.313 169.035 990.567 168.876 990.677 168.631L994.713 159.625C994.75 159.543 994.769 159.456 994.769 159.367Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 971.968,
    y: 113.688,
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.894,
    y: 113.688,
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.974 128.607C885.974 128.22 886.288 127.906 886.675 127.906H929.251C929.638 127.906 929.952 128.22 929.952 128.607V144.692C929.952 145.08 929.638 145.393 929.251 145.393H886.675C886.288 145.393 885.974 145.08 885.974 144.692V128.607Z",
    fill: "url(#paint8_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.974 128.607C885.974 128.22 886.288 127.906 886.675 127.906H929.251C929.638 127.906 929.952 128.22 929.952 128.607V144.692C929.952 145.08 929.638 145.393 929.251 145.393H886.675C886.288 145.393 885.974 145.08 885.974 144.692V128.607Z",
    fill: "url(#paint9_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.454 115.427H930.744C931.131 115.427 931.445 115.741 931.445 116.128V147.537C931.445 147.924 931.131 148.238 930.744 148.238H885.454C885.067 148.238 884.753 147.924 884.753 147.537V116.128C884.753 115.741 885.067 115.427 885.454 115.427ZM929.952 118.972C929.952 118.585 929.638 118.271 929.251 118.271H886.675C886.288 118.271 885.974 118.585 885.974 118.972V124.746C885.974 125.134 886.279 125.449 886.667 125.448H929.251C929.638 125.448 929.952 125.134 929.952 124.746V118.972ZM929.251 127.906H886.675C886.288 127.906 885.974 128.22 885.974 128.607V144.692C885.974 145.08 886.288 145.393 886.675 145.393H929.251C929.638 145.393 929.952 145.08 929.952 144.692V128.607C929.952 128.22 929.638 127.906 929.251 127.906Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.675 118.271H929.251C929.638 118.271 929.952 118.585 929.952 118.972V124.746C929.952 125.134 929.638 125.448 929.251 125.448H886.667C886.279 125.449 885.974 125.134 885.974 124.746V118.972C885.974 118.585 886.288 118.271 886.675 118.271Z",
    fill: "url(#paint10_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.675 118.271H929.251C929.638 118.271 929.952 118.585 929.952 118.972V124.746C929.952 125.134 929.638 125.448 929.251 125.448H886.667C886.279 125.449 885.974 125.134 885.974 124.746V118.972C885.974 118.585 886.288 118.271 886.675 118.271Z",
    fill: "url(#paint11_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.974 128.607C885.974 128.22 886.288 127.906 886.675 127.906H929.251C929.638 127.906 929.952 128.22 929.952 128.607V144.692C929.952 145.08 929.638 145.393 929.251 145.393H886.675C886.288 145.393 885.974 145.08 885.974 144.692V128.607Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M885.454 115.427H930.744C931.131 115.427 931.445 115.741 931.445 116.128V147.537C931.445 147.924 931.131 148.238 930.744 148.238H885.454C885.067 148.238 884.753 147.924 884.753 147.537V116.128C884.753 115.741 885.067 115.427 885.454 115.427ZM929.952 118.972C929.952 118.585 929.638 118.271 929.251 118.271H886.675C886.288 118.271 885.974 118.585 885.974 118.972V124.746C885.974 125.134 886.279 125.449 886.667 125.448H929.251C929.638 125.448 929.952 125.134 929.952 124.746V118.972ZM929.251 127.906H886.675C886.288 127.906 885.974 128.22 885.974 128.607V144.692C885.974 145.08 886.288 145.393 886.675 145.393H929.251C929.638 145.393 929.952 145.08 929.952 144.692V128.607C929.952 128.22 929.638 127.906 929.251 127.906Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.675 118.271H929.251C929.638 118.271 929.952 118.585 929.952 118.972V124.746C929.952 125.134 929.638 125.448 929.251 125.448H886.667C886.279 125.449 885.974 125.134 885.974 124.746V118.972C885.974 118.585 886.288 118.271 886.675 118.271Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.18 128.607C1019.18 128.22 1019.5 127.906 1019.88 127.906H1062.46C1062.85 127.906 1063.16 128.22 1063.16 128.607V144.692C1063.16 145.08 1062.85 145.393 1062.46 145.393H1019.88C1019.5 145.393 1019.18 145.08 1019.18 144.692V128.607Z",
    fill: "url(#paint12_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.18 128.607C1019.18 128.22 1019.5 127.906 1019.88 127.906H1062.46C1062.85 127.906 1063.16 128.22 1063.16 128.607V144.692C1063.16 145.08 1062.85 145.393 1062.46 145.393H1019.88C1019.5 145.393 1019.18 145.08 1019.18 144.692V128.607Z",
    fill: "url(#paint13_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.66 115.427H1063.95C1064.34 115.427 1064.65 115.741 1064.65 116.128V147.537C1064.65 147.924 1064.34 148.238 1063.95 148.238H1018.66C1018.27 148.238 1017.96 147.924 1017.96 147.537V116.128C1017.96 115.741 1018.27 115.427 1018.66 115.427ZM1063.16 118.972C1063.16 118.585 1062.85 118.271 1062.46 118.271H1019.88C1019.5 118.271 1019.18 118.585 1019.18 118.972V124.746C1019.18 125.134 1019.49 125.449 1019.88 125.448H1062.46C1062.85 125.448 1063.16 125.134 1063.16 124.746V118.972ZM1062.46 127.906H1019.88C1019.5 127.906 1019.18 128.22 1019.18 128.607V144.692C1019.18 145.08 1019.5 145.393 1019.88 145.393H1062.46C1062.85 145.393 1063.16 145.08 1063.16 144.692V128.607C1063.16 128.22 1062.85 127.906 1062.46 127.906Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.88 118.271H1062.46C1062.85 118.271 1063.16 118.585 1063.16 118.972V124.746C1063.16 125.134 1062.85 125.448 1062.46 125.448H1019.88C1019.49 125.449 1019.18 125.134 1019.18 124.746V118.972C1019.18 118.585 1019.5 118.271 1019.88 118.271Z",
    fill: "url(#paint14_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.88 118.271H1062.46C1062.85 118.271 1063.16 118.585 1063.16 118.972V124.746C1063.16 125.134 1062.85 125.448 1062.46 125.448H1019.88C1019.49 125.449 1019.18 125.134 1019.18 124.746V118.972C1019.18 118.585 1019.5 118.271 1019.88 118.271Z",
    fill: "url(#paint15_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.18 128.607C1019.18 128.22 1019.5 127.906 1019.88 127.906H1062.46C1062.85 127.906 1063.16 128.22 1063.16 128.607V144.692C1063.16 145.08 1062.85 145.393 1062.46 145.393H1019.88C1019.5 145.393 1019.18 145.08 1019.18 144.692V128.607Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1018.66 115.427H1063.95C1064.34 115.427 1064.65 115.741 1064.65 116.128V147.537C1064.65 147.924 1064.34 148.238 1063.95 148.238H1018.66C1018.27 148.238 1017.96 147.924 1017.96 147.537V116.128C1017.96 115.741 1018.27 115.427 1018.66 115.427ZM1063.16 118.972C1063.16 118.585 1062.85 118.271 1062.46 118.271H1019.88C1019.5 118.271 1019.18 118.585 1019.18 118.972V124.746C1019.18 125.134 1019.49 125.449 1019.88 125.448H1062.46C1062.85 125.448 1063.16 125.134 1063.16 124.746V118.972ZM1062.46 127.906H1019.88C1019.5 127.906 1019.18 128.22 1019.18 128.607V144.692C1019.18 145.08 1019.5 145.393 1019.88 145.393H1062.46C1062.85 145.393 1063.16 145.08 1063.16 144.692V128.607C1063.16 128.22 1062.85 127.906 1062.46 127.906Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.88 118.271H1062.46C1062.85 118.271 1063.16 118.585 1063.16 118.972V124.746C1063.16 125.134 1062.85 125.448 1062.46 125.448H1019.88C1019.49 125.449 1019.18 125.134 1019.18 124.746V118.972C1019.18 118.585 1019.5 118.271 1019.88 118.271Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.159 111.038C753.267 112.34 744.05 137.131 741.898 150.164C741.781 150.873 742.601 151.306 743.146 150.838L758.002 138.081C758.002 138.081 758.431 137.396 758.431 136.856V112.305C758.431 111.581 758.13 110.991 757.758 110.99L755.383 110.97C755.307 110.97 755.232 110.991 755.16 111.04L755.159 111.038Z",
    fill: "#D4D5DF",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.602 112.116C755.434 112.117 755.288 112.24 755.216 112.451C754.406 114.849 749.886 123.872 745.315 141.623C745.156 142.656 743.515 148.509 743.427 149.147C743.421 149.19 743.451 149.185 743.484 149.156L756.759 137.617C756.759 137.617 757.115 137.003 757.115 136.519L757.32 112.966C757.32 112.316 757.108 112.117 756.799 112.115C756.377 112.102 756.079 112.111 755.602 112.116Z",
    fill: "url(#paint16_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.602 112.116C755.434 112.117 755.288 112.24 755.216 112.451C754.406 114.849 749.886 123.872 745.315 141.623C745.156 142.656 743.515 148.509 743.427 149.147C743.421 149.19 743.451 149.185 743.484 149.156L756.759 137.617C756.759 137.617 757.115 137.003 757.115 136.519L757.32 112.966C757.32 112.316 757.108 112.117 756.799 112.115C756.377 112.102 756.079 112.111 755.602 112.116Z",
    fill: "url(#paint17_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.602 112.116C755.434 112.117 755.288 112.24 755.216 112.451C754.406 114.849 749.886 123.872 745.315 141.623C745.156 142.656 743.515 148.509 743.427 149.147C743.421 149.19 743.451 149.185 743.484 149.156L756.759 137.617C756.759 137.617 757.115 137.003 757.115 136.519L757.32 112.966C757.32 112.316 757.108 112.117 756.799 112.115C756.377 112.102 756.079 112.111 755.602 112.116Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1081_118500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.49 224.522H-216.012V231.533H364.49V224.522Z",
    fill: "#958A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.053 152.796H339.42V152.798C347.006 152.798 363.265 185.09 365.285 218.189C365.3 218.314 365.315 218.439 365.329 218.563C365.336 219.15 365.323 219.731 365.294 220.298C365.185 224.731 364.595 228.376 364.595 228.376H326.053V228.304H-216.284V152.928H323.859C324.576 152.928 325.308 152.999 326.053 153.139V152.796Z",
    fill: "white",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.124 223.69L366.911 223.541C367.606 225.598 366.335 231.785 366.335 231.785H237.078V231.784H-216.152V223.69H237.124Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.911 223.541L367.185 223.448L367.119 223.252L366.911 223.252L366.911 223.541ZM237.124 223.69V223.979L237.125 223.979L237.124 223.69ZM366.335 231.785V232.074H366.571L366.618 231.843L366.335 231.785ZM237.078 231.785H236.789V232.074H237.078V231.785ZM237.078 231.784H237.368V231.495H237.078V231.784ZM-216.152 231.784H-216.441V232.074H-216.152V231.784ZM-216.152 223.69V223.401H-216.441V223.69H-216.152ZM366.911 223.252L237.124 223.401L237.125 223.979L366.912 223.83L366.911 223.252ZM366.335 231.785C366.618 231.843 366.618 231.843 366.618 231.843C366.618 231.843 366.618 231.843 366.618 231.843C366.618 231.842 366.619 231.842 366.619 231.842C366.619 231.841 366.619 231.84 366.619 231.838C366.62 231.835 366.621 231.83 366.622 231.824C366.625 231.812 366.628 231.795 366.633 231.771C366.642 231.725 366.655 231.657 366.672 231.57C366.706 231.395 366.753 231.144 366.808 230.836C366.916 230.221 367.054 229.379 367.171 228.471C367.287 227.564 367.382 226.587 367.403 225.704C367.425 224.83 367.376 224.014 367.185 223.448L366.637 223.634C366.794 224.096 366.847 224.825 366.825 225.69C366.804 226.545 366.712 227.501 366.597 228.398C366.482 229.294 366.346 230.126 366.238 230.736C366.184 231.04 366.138 231.288 366.104 231.46C366.088 231.546 366.075 231.613 366.066 231.658C366.061 231.681 366.058 231.698 366.055 231.71C366.054 231.715 366.053 231.72 366.053 231.723C366.052 231.724 366.052 231.725 366.052 231.726C366.052 231.726 366.052 231.726 366.052 231.726C366.052 231.727 366.052 231.727 366.052 231.727C366.052 231.727 366.052 231.727 366.335 231.785ZM237.078 232.074H366.335V231.496H237.078V232.074ZM236.789 231.784V231.785H237.368V231.784H236.789ZM-216.152 232.074H237.078V231.495H-216.152V232.074ZM-216.441 223.69V231.784H-215.863V223.69H-216.441ZM237.124 223.401H-216.152V223.979H237.124V223.401Z",
    fill: "#232222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.939 215.324C294.571 215.324 294.274 215.028 294.274 214.66V195.231C294.274 194.864 294.571 194.567 294.939 194.567C295.306 194.567 295.603 194.864 295.603 195.231V214.66C295.603 215.028 295.306 215.324 294.939 215.324Z",
    fill: "#D9D9D9",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.724 215.324C324.356 215.324 324.06 215.028 324.06 214.66V195.231C324.06 194.864 324.356 194.567 324.724 194.567C325.092 194.567 325.388 194.864 325.388 195.231V214.66C325.388 215.028 325.092 215.324 324.724 215.324Z",
    fill: "#D9D9D9",
    stroke: "#9A9797",
    strokeWidth: 0.0280436,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.308 152.871H-216.853V147.543H-202.967H316.491C331.777 147.543 341.578 151.635 343.308 152.871Z",
    fill: "#B1CEDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-216.012 154.661V151.504L329.288 151.151C329.288 151.151 336.419 150.996 342.112 152.834C354.183 158.254 368.641 206.982 368.641 221.521C368.641 224.063 366.542 223.925 365.034 223.925H-216.284V220.737H363.224C361.237 207.263 346.847 155.659 336.882 155.659L-216.012 154.661Z",
    fill: "#F8C8C4",
    stroke: "#9A9797",
    strokeWidth: 0.494328,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.942 218.738C322.942 219.842 322.048 220.737 320.944 220.737L299.046 220.735C297.943 220.735 297.048 219.84 297.048 218.737V162.139C297.048 161.035 297.943 160.141 299.046 160.141L320.944 160.141C322.048 160.141 322.942 161.035 322.942 162.139V218.738Z",
    fill: "white",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.689 165.217H303.512C302.358 165.217 301.423 166.152 301.423 167.306V195.551C301.423 196.705 302.358 197.64 303.512 197.64H316.689C317.842 197.64 318.778 196.705 318.778 195.551V167.306C318.778 166.152 317.842 165.217 316.689 165.217Z",
    fill: "#9A9EB2",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.689 165.217H303.512C302.358 165.217 301.423 166.152 301.423 167.306V195.551C301.423 196.705 302.358 197.64 303.512 197.64H316.689C317.842 197.64 318.778 196.705 318.778 195.551V167.306C318.778 166.152 317.842 165.217 316.689 165.217Z",
    fill: "#9A9EB2",
    stroke: "#232222",
    strokeWidth: 0.289133,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.681 165.901H304.577C303.424 165.901 302.488 166.837 302.488 167.99V194.831C302.488 195.985 303.424 196.92 304.577 196.92H315.681C316.834 196.92 317.77 195.985 317.77 194.831V167.99C317.77 166.837 316.834 165.901 315.681 165.901Z",
    fill: "url(#paint18_linear_1081_118500)",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.22 160.043C280.22 159.677 279.906 159.381 279.519 159.381H254.901C254.514 159.381 254.2 159.677 254.2 160.043V223.218C254.2 223.584 254.514 223.88 254.901 223.88H279.519C279.906 223.88 280.22 223.584 280.22 223.218V160.043ZM274.257 165.674C274.257 165.308 273.943 165.012 273.556 165.012H258.767C258.379 165.012 258.066 165.308 258.066 165.674V218.436C258.066 218.802 258.379 219.098 258.767 219.098H269.52C269.801 219.098 270.055 218.939 270.165 218.694L274.202 209.688C274.238 209.607 274.257 209.519 274.257 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.066 165.674C258.066 165.308 258.379 165.012 258.767 165.012H273.556C273.943 165.012 274.257 165.308 274.257 165.674V209.43C274.257 209.519 274.238 209.607 274.202 209.688L270.165 218.694C270.055 218.939 269.801 219.098 269.52 219.098H258.767C258.379 219.098 258.066 218.802 258.066 218.436V165.674Z",
    fill: "url(#paint19_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.066 165.674C258.066 165.308 258.379 165.012 258.767 165.012H273.556C273.943 165.012 274.257 165.308 274.257 165.674V209.43C274.257 209.519 274.238 209.607 274.202 209.688L270.165 218.694C270.055 218.939 269.801 219.098 269.52 219.098H258.767C258.379 219.098 258.066 218.802 258.066 218.436V165.674Z",
    fill: "url(#paint20_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.18 160.043C228.18 159.677 228.494 159.381 228.881 159.381H253.499C253.886 159.381 254.2 159.677 254.2 160.043V223.218C254.2 223.584 253.886 223.88 253.499 223.88H228.881C228.494 223.88 228.18 223.584 228.18 223.218V160.043ZM234.143 165.674C234.143 165.308 234.457 165.012 234.844 165.012H249.634C250.021 165.012 250.335 165.308 250.335 165.674V218.436C250.335 218.802 250.021 219.098 249.634 219.098H238.881C238.599 219.098 238.345 218.939 238.235 218.694L234.199 209.688C234.162 209.607 234.143 209.519 234.143 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.335 165.674C250.335 165.308 250.021 165.012 249.634 165.012H234.844C234.457 165.012 234.143 165.308 234.143 165.674V209.43C234.143 209.519 234.162 209.607 234.199 209.688L238.235 218.694C238.345 218.939 238.599 219.098 238.881 219.098H249.634C250.021 219.098 250.335 218.802 250.335 218.436V165.674Z",
    fill: "url(#paint21_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2 223.218V160.043M254.2 223.218C254.2 223.584 254.514 223.88 254.901 223.88H279.519C279.906 223.88 280.22 223.584 280.22 223.218V160.043C280.22 159.677 279.906 159.381 279.519 159.381H254.901C254.514 159.381 254.2 159.677 254.2 160.043M254.2 223.218C254.2 223.584 253.886 223.88 253.499 223.88H228.881C228.494 223.88 228.18 223.584 228.18 223.218V160.043C228.18 159.677 228.494 159.381 228.881 159.381H253.499C253.886 159.381 254.2 159.677 254.2 160.043M274.257 209.43V165.674C274.257 165.308 273.943 165.012 273.556 165.012H258.767C258.379 165.012 258.066 165.308 258.066 165.674V218.436C258.066 218.802 258.379 219.098 258.767 219.098H269.52C269.801 219.098 270.055 218.939 270.165 218.694L274.202 209.688C274.238 209.607 274.257 209.519 274.257 209.43ZM234.143 209.43V165.674C234.143 165.308 234.457 165.012 234.844 165.012H249.634C250.021 165.012 250.335 165.308 250.335 165.674V218.436C250.335 218.802 250.021 219.098 249.634 219.098H238.881C238.599 219.098 238.345 218.939 238.235 218.694L234.199 209.688C234.162 209.607 234.143 209.519 234.143 209.43Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    transform: "matrix(-1 0 0 1 256.943 163.751)",
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    transform: "matrix(-1 0 0 1 253.018 163.751)",
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.013 160.043C147.013 159.677 146.699 159.381 146.312 159.381H121.694C121.307 159.381 120.993 159.677 120.993 160.043V223.218C120.993 223.584 121.307 223.88 121.694 223.88H146.312C146.699 223.88 147.013 223.584 147.013 223.218V160.043ZM141.05 165.674C141.05 165.308 140.736 165.012 140.349 165.012H125.56C125.172 165.012 124.859 165.308 124.859 165.674V218.436C124.859 218.802 125.172 219.098 125.56 219.098H136.312C136.594 219.098 136.848 218.939 136.958 218.694L140.995 209.688C141.031 209.607 141.05 209.519 141.05 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.859 165.674C124.859 165.308 125.172 165.012 125.56 165.012H140.349C140.736 165.012 141.05 165.308 141.05 165.674V209.43C141.05 209.519 141.031 209.607 140.995 209.688L136.958 218.694C136.848 218.939 136.594 219.098 136.312 219.098H125.56C125.172 219.098 124.859 218.802 124.859 218.436V165.674Z",
    fill: "url(#paint22_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.859 165.674C124.859 165.308 125.172 165.012 125.56 165.012H140.349C140.736 165.012 141.05 165.308 141.05 165.674V209.43C141.05 209.519 141.031 209.607 140.995 209.688L136.958 218.694C136.848 218.939 136.594 219.098 136.312 219.098H125.56C125.172 219.098 124.859 218.802 124.859 218.436V165.674Z",
    fill: "url(#paint23_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9733 160.043C94.9733 159.677 95.2872 159.381 95.6744 159.381H120.292C120.679 159.381 120.993 159.677 120.993 160.043V223.218C120.993 223.584 120.679 223.88 120.292 223.88H95.6744C95.2872 223.88 94.9733 223.584 94.9733 223.218V160.043ZM100.936 165.674C100.936 165.308 101.25 165.012 101.637 165.012H116.427C116.814 165.012 117.128 165.308 117.128 165.674V218.436C117.128 218.802 116.814 219.098 116.427 219.098H105.674C105.392 219.098 105.138 218.939 105.028 218.694L100.992 209.688C100.955 209.607 100.936 209.519 100.936 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.128 165.674C117.128 165.308 116.814 165.012 116.427 165.012H101.637C101.25 165.012 100.936 165.308 100.936 165.674V209.43C100.936 209.519 100.955 209.607 100.992 209.688L105.028 218.694C105.138 218.939 105.392 219.098 105.674 219.098H116.427C116.814 219.098 117.128 218.802 117.128 218.436V165.674Z",
    fill: "url(#paint24_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.993 223.218V160.043M120.993 223.218C120.993 223.584 121.307 223.88 121.694 223.88H146.312C146.699 223.88 147.013 223.584 147.013 223.218V160.043C147.013 159.677 146.699 159.381 146.312 159.381H121.694C121.307 159.381 120.993 159.677 120.993 160.043M120.993 223.218C120.993 223.584 120.679 223.88 120.292 223.88H95.6744C95.2872 223.88 94.9733 223.584 94.9733 223.218V160.043C94.9733 159.677 95.2872 159.381 95.6744 159.381H120.292C120.679 159.381 120.993 159.677 120.993 160.043M141.05 209.43V165.674C141.05 165.308 140.736 165.012 140.349 165.012H125.56C125.172 165.012 124.859 165.308 124.859 165.674V218.436C124.859 218.802 125.172 219.098 125.56 219.098H136.312C136.594 219.098 136.848 218.939 136.958 218.694L140.995 209.688C141.031 209.607 141.05 209.519 141.05 209.43ZM100.936 209.43V165.674C100.936 165.308 101.25 165.012 101.637 165.012H116.427C116.814 165.012 117.128 165.308 117.128 165.674V218.436C117.128 218.802 116.814 219.098 116.427 219.098H105.674C105.392 219.098 105.138 218.939 105.028 218.694L100.992 209.688C100.955 209.607 100.936 209.519 100.936 209.43Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    transform: "matrix(-1 0 0 1 123.737 163.751)",
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.40218,
    height: 56.4072,
    rx: 0.420653,
    transform: "matrix(-1 0 0 1 119.811 163.751)",
    fill: "#D9D9D9",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.807 160.043C13.807 159.677 13.4931 159.381 13.1059 159.381H-11.5117C-11.8989 159.381 -12.2128 159.677 -12.2128 160.043V223.218C-12.2128 223.584 -11.8989 223.88 -11.5117 223.88H13.1059C13.4931 223.88 13.807 223.584 13.807 223.218V160.043ZM7.84414 165.674C7.84414 165.308 7.53025 165.012 7.14305 165.012H-7.64632C-8.03352 165.012 -8.34741 165.308 -8.34741 165.674V218.436C-8.34741 218.802 -8.03352 219.098 -7.64632 219.098H3.10654C3.38814 219.098 3.64242 218.939 3.75218 218.694L7.78869 209.688C7.82528 209.607 7.84414 209.519 7.84414 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.34741 165.674C-8.34741 165.308 -8.03352 165.012 -7.64632 165.012H7.14305C7.53025 165.012 7.84414 165.308 7.84414 165.674V209.43C7.84414 209.519 7.82528 209.607 7.78869 209.688L3.75218 218.694C3.64242 218.939 3.38814 219.098 3.10654 219.098H-7.64632C-8.03352 219.098 -8.34741 218.802 -8.34741 218.436V165.674Z",
    fill: "url(#paint25_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-38.2326 160.043C-38.2326 159.677 -37.9187 159.381 -37.5315 159.381H-12.9139C-12.5267 159.381 -12.2128 159.677 -12.2128 160.043V223.218C-12.2128 223.584 -12.5267 223.88 -12.9139 223.88H-37.5315C-37.9187 223.88 -38.2326 223.584 -38.2326 223.218V160.043ZM-32.2697 165.674C-32.2697 165.308 -31.9558 165.012 -31.5686 165.012H-16.7793C-16.3921 165.012 -16.0782 165.308 -16.0782 165.674V218.436C-16.0782 218.802 -16.3921 219.098 -16.7793 219.098H-27.5321C-27.8137 219.098 -28.068 218.939 -28.1778 218.694L-32.2143 209.688C-32.2509 209.607 -32.2697 209.519 -32.2697 209.43V165.674Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.0782 165.674C-16.0782 165.308 -16.3921 165.012 -16.7793 165.012H-31.5686C-31.9558 165.012 -32.2697 165.308 -32.2697 165.674V209.43C-32.2697 209.519 -32.2509 209.607 -32.2143 209.688L-28.1778 218.694C-28.068 218.939 -27.8137 219.098 -27.5321 219.098H-16.7793C-16.3921 219.098 -16.0782 218.802 -16.0782 218.436V165.674Z",
    fill: "url(#paint26_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.2128 223.218V160.043M-12.2128 223.218C-12.2128 223.584 -11.8989 223.88 -11.5117 223.88H13.1059C13.4931 223.88 13.807 223.584 13.807 223.218V160.043C13.807 159.677 13.4931 159.381 13.1059 159.381H-11.5117C-11.8989 159.381 -12.2128 159.677 -12.2128 160.043M-12.2128 223.218C-12.2128 223.584 -12.5267 223.88 -12.9139 223.88H-37.5315C-37.9187 223.88 -38.2326 223.584 -38.2326 223.218V160.043C-38.2326 159.677 -37.9187 159.381 -37.5315 159.381H-12.9139C-12.5267 159.381 -12.2128 159.677 -12.2128 160.043M7.84414 209.43V165.674C7.84414 165.308 7.53025 165.012 7.14305 165.012H-7.64632C-8.03352 165.012 -8.34741 165.308 -8.34741 165.674V218.436C-8.34741 218.802 -8.03352 219.098 -7.64632 219.098H3.10654C3.38814 219.098 3.64242 218.939 3.75218 218.694L7.78869 209.688C7.82528 209.607 7.84414 209.519 7.84414 209.43ZM-32.2697 209.43V165.674C-32.2697 165.308 -31.9558 165.012 -31.5686 165.012H-16.7793C-16.3921 165.012 -16.0782 165.308 -16.0782 165.674V218.436C-16.0782 218.802 -16.3921 219.098 -16.7793 219.098H-27.5321C-27.8137 219.098 -28.068 218.939 -28.1778 218.694L-32.2143 209.688C-32.2509 209.607 -32.2697 209.519 -32.2697 209.43Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.731 178.672C209.731 178.284 209.417 177.971 209.03 177.971H166.454C166.067 177.971 165.753 178.284 165.753 178.672V194.757C165.753 195.144 166.067 195.458 166.454 195.458H209.03C209.417 195.458 209.731 195.144 209.731 194.757V178.672Z",
    fill: "url(#paint27_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.731 178.672C209.731 178.284 209.417 177.971 209.03 177.971H166.454C166.067 177.971 165.753 178.284 165.753 178.672V194.757C165.753 195.144 166.067 195.458 166.454 195.458H209.03C209.417 195.458 209.731 195.144 209.731 194.757V178.672Z",
    fill: "url(#paint28_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.251 165.491H164.961C164.574 165.491 164.26 165.805 164.26 166.192V197.601C164.26 197.988 164.574 198.302 164.961 198.302H210.251C210.639 198.302 210.952 197.988 210.952 197.601V166.192C210.952 165.805 210.639 165.491 210.251 165.491ZM165.753 169.037C165.753 168.649 166.067 168.336 166.454 168.336H209.03C209.417 168.336 209.731 168.649 209.731 169.037V174.811C209.731 175.199 209.426 175.513 209.038 175.512H166.454C166.067 175.512 165.753 175.198 165.753 174.811V169.037ZM166.454 177.971H209.03C209.417 177.971 209.731 178.284 209.731 178.672V194.757C209.731 195.144 209.417 195.458 209.03 195.458H166.454C166.067 195.458 165.753 195.144 165.753 194.757V178.672C165.753 178.284 166.067 177.971 166.454 177.971Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.03 168.336H166.454C166.067 168.336 165.753 168.649 165.753 169.037V174.811C165.753 175.198 166.067 175.512 166.454 175.512H209.038C209.426 175.513 209.731 175.199 209.731 174.811V169.037C209.731 168.649 209.417 168.336 209.03 168.336Z",
    fill: "url(#paint29_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.03 168.336H166.454C166.067 168.336 165.753 168.649 165.753 169.037V174.811C165.753 175.198 166.067 175.512 166.454 175.512H209.038C209.426 175.513 209.731 175.199 209.731 174.811V169.037C209.731 168.649 209.417 168.336 209.03 168.336Z",
    fill: "url(#paint30_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.731 178.672C209.731 178.284 209.417 177.971 209.03 177.971H166.454C166.067 177.971 165.753 178.284 165.753 178.672V194.757C165.753 195.144 166.067 195.458 166.454 195.458H209.03C209.417 195.458 209.731 195.144 209.731 194.757V178.672Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.251 165.491H164.961C164.574 165.491 164.26 165.805 164.26 166.192V197.601C164.26 197.988 164.574 198.302 164.961 198.302H210.251C210.639 198.302 210.952 197.988 210.952 197.601V166.192C210.952 165.805 210.639 165.491 210.251 165.491ZM165.753 169.037C165.753 168.649 166.067 168.336 166.454 168.336H209.03C209.417 168.336 209.731 168.649 209.731 169.037V174.811C209.731 175.199 209.426 175.513 209.038 175.512H166.454C166.067 175.512 165.753 175.198 165.753 174.811V169.037ZM166.454 177.971H209.03C209.417 177.971 209.731 178.284 209.731 178.672V194.757C209.731 195.144 209.417 195.458 209.03 195.458H166.454C166.067 195.458 165.753 195.144 165.753 194.757V178.672C165.753 178.284 166.067 177.971 166.454 177.971Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.03 168.336H166.454C166.067 168.336 165.753 168.649 165.753 169.037V174.811C165.753 175.198 166.067 175.512 166.454 175.512H209.038C209.426 175.513 209.731 175.199 209.731 174.811V169.037C209.731 168.649 209.417 168.336 209.03 168.336Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.523 178.672C76.523 178.284 76.2091 177.971 75.8219 177.971H33.2463C32.8591 177.971 32.5452 178.284 32.5452 178.672V194.757C32.5452 195.144 32.8591 195.458 33.2463 195.458H75.8219C76.2091 195.458 76.523 195.144 76.523 194.757V178.672Z",
    fill: "url(#paint31_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.523 178.672C76.523 178.284 76.2091 177.971 75.8219 177.971H33.2463C32.8591 177.971 32.5452 178.284 32.5452 178.672V194.757C32.5452 195.144 32.8591 195.458 33.2463 195.458H75.8219C76.2091 195.458 76.523 195.144 76.523 194.757V178.672Z",
    fill: "url(#paint32_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0435 165.491H31.7532C31.366 165.491 31.0521 165.805 31.0521 166.192V197.601C31.0521 197.988 31.366 198.302 31.7532 198.302H77.0435C77.4307 198.302 77.7446 197.988 77.7446 197.601V166.192C77.7446 165.805 77.4307 165.491 77.0435 165.491ZM32.5452 169.037C32.5452 168.649 32.8591 168.336 33.2463 168.336H75.8219C76.2091 168.336 76.523 168.649 76.523 169.037V174.811C76.523 175.199 76.2181 175.513 75.83 175.512H33.2463C32.8591 175.512 32.5452 175.198 32.5452 174.811V169.037ZM33.2463 177.971H75.8219C76.2091 177.971 76.523 178.284 76.523 178.672V194.757C76.523 195.144 76.2091 195.458 75.8219 195.458H33.2463C32.8591 195.458 32.5452 195.144 32.5452 194.757V178.672C32.5452 178.284 32.8591 177.971 33.2463 177.971Z",
    fill: "#D4D5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8219 168.336H33.2463C32.8591 168.336 32.5452 168.649 32.5452 169.037V174.811C32.5452 175.198 32.8591 175.512 33.2463 175.512H75.83C76.2181 175.513 76.523 175.199 76.523 174.811V169.037C76.523 168.649 76.2091 168.336 75.8219 168.336Z",
    fill: "url(#paint33_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8219 168.336H33.2463C32.8591 168.336 32.5452 168.649 32.5452 169.037V174.811C32.5452 175.198 32.8591 175.512 33.2463 175.512H75.83C76.2181 175.513 76.523 175.199 76.523 174.811V169.037C76.523 168.649 76.2091 168.336 75.8219 168.336Z",
    fill: "url(#paint34_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.523 178.672C76.523 178.284 76.2091 177.971 75.8219 177.971H33.2463C32.8591 177.971 32.5452 178.284 32.5452 178.672V194.757C32.5452 195.144 32.8591 195.458 33.2463 195.458H75.8219C76.2091 195.458 76.523 195.144 76.523 194.757V178.672Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0435 165.491H31.7532C31.366 165.491 31.0521 165.805 31.0521 166.192V197.601C31.0521 197.988 31.366 198.302 31.7532 198.302H77.0435C77.4307 198.302 77.7446 197.988 77.7446 197.601V166.192C77.7446 165.805 77.4307 165.491 77.0435 165.491ZM32.5452 169.037C32.5452 168.649 32.8591 168.336 33.2463 168.336H75.8219C76.2091 168.336 76.523 168.649 76.523 169.037V174.811C76.523 175.199 76.2181 175.513 75.83 175.512H33.2463C32.8591 175.512 32.5452 175.198 32.5452 174.811V169.037ZM33.2463 177.971H75.8219C76.2091 177.971 76.523 178.284 76.523 178.672V194.757C76.523 195.144 76.2091 195.458 75.8219 195.458H33.2463C32.8591 195.458 32.5452 195.144 32.5452 194.757V178.672C32.5452 178.284 32.8591 177.971 33.2463 177.971Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8219 168.336H33.2463C32.8591 168.336 32.5452 168.649 32.5452 169.037V174.811C32.5452 175.198 32.8591 175.512 33.2463 175.512H75.83C76.2181 175.513 76.523 175.199 76.523 174.811V169.037C76.523 168.649 76.2091 168.336 75.8219 168.336Z",
    stroke: "#645757",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.546 161.102C342.438 162.403 351.655 187.195 353.807 200.228C353.924 200.936 353.104 201.369 352.559 200.901L337.704 188.145C337.704 188.145 337.274 187.46 337.274 186.919V162.368C337.274 161.644 337.575 161.055 337.947 161.053L340.322 161.033C340.398 161.033 340.473 161.055 340.545 161.103L340.546 161.102Z",
    fill: "#D4D5DF",
    stroke: "#232222",
    strokeWidth: 0.289133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.104 162.179C340.271 162.18 340.418 162.303 340.489 162.514C341.299 164.912 345.819 173.935 350.39 191.687C350.55 192.72 352.191 198.572 352.278 199.211C352.284 199.254 352.254 199.248 352.222 199.22L338.946 187.681C338.946 187.681 338.59 187.067 338.59 186.582L338.386 163.029C338.386 162.38 338.598 162.181 338.906 162.179C339.329 162.165 339.626 162.175 340.104 162.179Z",
    fill: "url(#paint35_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.104 162.179C340.271 162.18 340.418 162.303 340.489 162.514C341.299 164.912 345.819 173.935 350.39 191.687C350.55 192.72 352.191 198.572 352.278 199.211C352.284 199.254 352.254 199.248 352.222 199.22L338.946 187.681C338.946 187.681 338.59 187.067 338.59 186.582L338.386 163.029C338.386 162.38 338.598 162.181 338.906 162.179C339.329 162.165 339.626 162.175 340.104 162.179Z",
    fill: "url(#paint36_linear_1081_118500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.104 162.179C340.271 162.18 340.418 162.303 340.489 162.514C341.299 164.912 345.819 173.935 350.39 191.687C350.55 192.72 352.191 198.572 352.278 199.211C352.284 199.254 352.254 199.248 352.222 199.22L338.946 187.681C338.946 187.681 338.59 187.067 338.59 186.582L338.386 163.029C338.386 162.38 338.598 162.181 338.906 162.179C339.329 162.165 339.626 162.175 340.104 162.179Z",
    stroke: "#232222",
    strokeWidth: 0.289133
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.4514 -12.5615V27.2676C18.4514 28.3562 17.5678 29.2399 16.4791 29.2399C15.3905 29.2399 14.5068 28.3562 14.5068 27.2676V-12.5615H18.4514Z",
    fill: "#ECC0BC",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4677 -12.5615V28.6889C55.4677 29.7775 54.584 30.6612 53.4954 30.6612C52.4067 30.6612 51.5231 29.7775 51.5231 28.6889V-12.5615H55.4677Z",
    fill: "#ECC0BC",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5422 21.4883H8.89902C4.59018 21.4883 1.09717 24.9813 1.09717 29.2901V47.3433C1.09717 51.6521 4.59018 55.1451 8.89902 55.1451H55.5422C59.851 55.1451 63.344 51.6521 63.344 47.3433V29.2901C63.344 24.9813 59.851 21.4883 55.5422 21.4883Z",
    fill: "#ECC0BC",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5698 21.4883H60.2129C64.5171 21.4883 68.0148 24.9827 68.0148 29.2901V47.3466C68.0148 51.6508 64.5204 55.1485 60.2129 55.1485H13.5698C9.26568 55.1485 5.76794 51.6541 5.76794 47.3466V29.2901C5.76794 24.986 9.26232 21.4883 13.5698 21.4883Z",
    fill: "#ACB2B9",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6194 27.2659C13.6194 27.9683 13.2229 28.5396 12.7356 28.5396C12.2482 28.5396 11.8517 27.9683 11.8517 27.2659C11.8517 26.5635 12.2482 25.9922 12.7356 25.9922C13.2229 25.9922 13.6194 26.5635 13.6194 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 27.2659C22.8655 27.9683 22.469 28.5396 21.9817 28.5396C21.4943 28.5396 21.0978 27.9683 21.0978 27.2659C21.0978 26.5635 21.4943 25.9922 21.9817 25.9922C22.469 25.9922 22.8655 26.5635 22.8655 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 27.2659C25.1769 27.9683 24.7804 28.5396 24.2931 28.5396C23.8057 28.5396 23.4092 27.9683 23.4092 27.2659C23.4092 26.5635 23.8057 25.9922 24.2931 25.9922C24.7804 25.9922 25.1769 26.5635 25.1769 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4933 27.2659C27.4933 27.9683 27.0968 28.5396 26.6095 28.5396C26.1222 28.5396 25.7256 27.9683 25.7256 27.2659C25.7256 26.5635 26.1222 25.9922 26.6095 25.9922C27.0968 25.9922 27.4933 26.5635 27.4933 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7388 27.2659C36.7388 27.9683 36.3423 28.5396 35.8549 28.5396C35.3676 28.5396 34.9711 27.9683 34.9711 27.2659C34.9711 26.5635 35.3676 25.9922 35.8549 25.9922C36.3423 25.9922 36.7388 26.5635 36.7388 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0524 27.2659C39.0524 27.9683 38.6559 28.5396 38.1685 28.5396C37.6812 28.5396 37.2847 27.9683 37.2847 27.2659C37.2847 26.5635 37.6812 25.9922 38.1685 25.9922C38.6559 25.9922 39.0524 26.5635 39.0524 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3655 27.2659C41.3655 27.9683 40.969 28.5396 40.4817 28.5396C39.9943 28.5396 39.5978 27.9683 39.5978 27.2659C39.5978 26.5635 39.9943 25.9922 40.4817 25.9922C40.969 25.9922 41.3655 26.5635 41.3655 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 27.2659C43.678 27.9683 43.2815 28.5396 42.7941 28.5396C42.3068 28.5396 41.9103 27.9683 41.9103 27.2659C41.9103 26.5635 42.3068 25.9922 42.7941 25.9922C43.2815 25.9922 43.678 26.5635 43.678 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9899 27.2659C45.9899 27.9683 45.5934 28.5396 45.106 28.5396C44.6187 28.5396 44.2222 27.9683 44.2222 27.2659C44.2222 26.5635 44.6187 25.9922 45.106 25.9922C45.5934 25.9922 45.9899 26.5635 45.9899 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2364 27.2659C55.2364 27.9683 54.8398 28.5396 54.3525 28.5396C53.8652 28.5396 53.4686 27.9683 53.4686 27.2659C53.4686 26.5635 53.8652 25.9922 54.3525 25.9922C54.8398 25.9922 55.2364 26.5635 55.2364 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5518 27.2659C57.5518 27.9683 57.1552 28.5396 56.6679 28.5396C56.1806 28.5396 55.7841 27.9683 55.7841 27.2659C55.7841 26.5635 56.1806 25.9922 56.6679 25.9922C57.1552 25.9922 57.5518 26.5635 57.5518 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8621 27.2659C59.8621 27.9683 59.4655 28.5396 58.9782 28.5396C58.4909 28.5396 58.0944 27.9683 58.0944 27.2659C58.0944 26.5635 58.4909 25.9922 58.9782 25.9922C59.4655 25.9922 59.8621 26.5635 59.8621 27.2659Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 30.3743C15.9302 31.0767 15.5337 31.648 15.0464 31.648C14.559 31.648 14.1625 31.0767 14.1625 30.3743C14.1625 29.6719 14.559 29.1006 15.0464 29.1006C15.5337 29.1006 15.9302 29.6719 15.9302 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3578 31.648C17.8459 31.648 18.2416 31.0778 18.2416 30.3743C18.2416 29.6708 17.8459 29.1006 17.3578 29.1006C16.8696 29.1006 16.4739 29.6708 16.4739 30.3743C16.4739 31.0778 16.8696 31.648 17.3578 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 30.3743C20.553 31.0767 20.1565 31.648 19.6692 31.648C19.1818 31.648 18.7853 31.0767 18.7853 30.3743C18.7853 29.6719 19.1818 29.1006 19.6692 29.1006C20.1565 29.1006 20.553 29.6719 20.553 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 30.3743C25.1769 31.0767 24.7804 31.648 24.2931 31.648C23.8057 31.648 23.4092 31.0767 23.4092 30.3743C23.4092 29.6719 23.8057 29.1006 24.2931 29.1006C24.7804 29.1006 25.1769 29.6719 25.1769 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 30.3743C29.8041 31.0767 29.4076 31.648 28.9203 31.648C28.4329 31.648 28.0364 31.0767 28.0364 30.3743C28.0364 29.6719 28.4329 29.1006 28.9203 29.1006C29.4076 29.1006 29.8041 29.6719 29.8041 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.231 31.648C31.7192 31.648 32.1149 31.0778 32.1149 30.3743C32.1149 29.6708 31.7192 29.1006 31.231 29.1006C30.7429 29.1006 30.3472 29.6708 30.3472 30.3743C30.3472 31.0778 30.7429 31.648 31.231 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5435 31.648C34.0317 31.648 34.4274 31.0778 34.4274 30.3743C34.4274 29.6708 34.0317 29.1006 33.5435 29.1006C33.0554 29.1006 32.6597 29.6708 32.6597 30.3743C32.6597 31.0778 33.0554 31.648 33.5435 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1707 31.648C38.6589 31.648 39.0546 31.0778 39.0546 30.3743C39.0546 29.6708 38.6589 29.1006 38.1707 29.1006C37.6826 29.1006 37.2869 29.6708 37.2869 30.3743C37.2869 31.0778 37.6826 31.648 38.1707 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4817 31.648C40.9698 31.648 41.3655 31.0778 41.3655 30.3743C41.3655 29.6708 40.9698 29.1006 40.4817 29.1006C39.9935 29.1006 39.5978 29.6708 39.5978 30.3743C39.5978 31.0778 39.9935 31.648 40.4817 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 30.3743C43.678 31.0767 43.2815 31.648 42.7941 31.648C42.3068 31.648 41.9103 31.0767 41.9103 30.3743C41.9103 29.6719 42.3068 29.1006 42.7941 29.1006C43.2815 29.1006 43.678 29.6719 43.678 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 30.3743C48.3007 31.0767 47.9041 31.648 47.4168 31.648C46.9295 31.648 46.533 31.0767 46.533 30.3743C46.533 29.6719 46.9295 29.1006 47.4168 29.1006C47.9041 29.1006 48.3007 29.6719 48.3007 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6679 31.648C57.1561 31.648 57.5518 31.0778 57.5518 30.3743C57.5518 29.6708 57.1561 29.1006 56.6679 29.1006C56.1798 29.1006 55.7841 29.6708 55.7841 30.3743C55.7841 31.0778 56.1798 31.648 56.6679 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 33.4827C15.9302 34.1851 15.5337 34.7564 15.0464 34.7564C14.559 34.7564 14.1625 34.1851 14.1625 33.4827C14.1625 32.7803 14.559 32.209 15.0464 32.209C15.5337 32.209 15.9302 32.7803 15.9302 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3578 34.7564C17.8459 34.7564 18.2416 34.1862 18.2416 33.4827C18.2416 32.7792 17.8459 32.209 17.3578 32.209C16.8696 32.209 16.4739 32.7792 16.4739 33.4827C16.4739 34.1862 16.8696 34.7564 17.3578 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 33.4827C20.553 34.1851 20.1565 34.7564 19.6692 34.7564C19.1818 34.7564 18.7853 34.1851 18.7853 33.4827C18.7853 32.7803 19.1818 32.209 19.6692 32.209C20.1565 32.209 20.553 32.7803 20.553 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 33.4827C25.1769 34.1851 24.7804 34.7564 24.2931 34.7564C23.8057 34.7564 23.4092 34.1851 23.4092 33.4827C23.4092 32.7803 23.8057 32.209 24.2931 32.209C24.7804 32.209 25.1769 32.7803 25.1769 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 33.4827C29.8041 34.1851 29.4076 34.7564 28.9203 34.7564C28.4329 34.7564 28.0364 34.1851 28.0364 33.4827C28.0364 32.7803 28.4329 32.209 28.9203 32.209C29.4076 32.209 29.8041 32.7803 29.8041 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.231 34.7564C31.7192 34.7564 32.1149 34.1862 32.1149 33.4827C32.1149 32.7792 31.7192 32.209 31.231 32.209C30.7429 32.209 30.3472 32.7792 30.3472 33.4827C30.3472 34.1862 30.7429 34.7564 31.231 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5435 34.7564C34.0317 34.7564 34.4274 34.1862 34.4274 33.4827C34.4274 32.7792 34.0317 32.209 33.5435 32.209C33.0554 32.209 32.6597 32.7792 32.6597 33.4827C32.6597 34.1862 33.0554 34.7564 33.5435 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1707 34.7564C38.6589 34.7564 39.0546 34.1862 39.0546 33.4827C39.0546 32.7792 38.6589 32.209 38.1707 32.209C37.6826 32.209 37.2869 32.7792 37.2869 33.4827C37.2869 34.1862 37.6826 34.7564 38.1707 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4817 34.7564C40.9698 34.7564 41.3655 34.1862 41.3655 33.4827C41.3655 32.7792 40.9698 32.209 40.4817 32.209C39.9935 32.209 39.5978 32.7792 39.5978 33.4827C39.5978 34.1862 39.9935 34.7564 40.4817 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 33.4827C43.678 34.1851 43.2815 34.7564 42.7941 34.7564C42.3068 34.7564 41.9103 34.1851 41.9103 33.4827C41.9103 32.7803 42.3068 32.209 42.7941 32.209C43.2815 32.209 43.678 32.7803 43.678 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 33.4827C50.612 34.1851 50.2154 34.7564 49.7281 34.7564C49.2408 34.7564 48.8442 34.1851 48.8442 33.4827C48.8442 32.7803 49.2408 32.209 49.7281 32.209C50.2154 32.209 50.612 32.7803 50.612 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9782 34.7564C59.4664 34.7564 59.8621 34.1862 59.8621 33.4827C59.8621 32.7792 59.4664 32.209 58.9782 32.209C58.4901 32.209 58.0944 32.7792 58.0944 33.4827C58.0944 34.1862 58.4901 34.7564 58.9782 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 36.5892C15.9302 37.2915 15.5337 37.8629 15.0464 37.8629C14.559 37.8629 14.1625 37.2915 14.1625 36.5892C14.1625 35.8868 14.559 35.3154 15.0464 35.3154C15.5337 35.3154 15.9302 35.8868 15.9302 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2416 36.5892C18.2416 37.2915 17.8451 37.8629 17.3578 37.8629C16.8704 37.8629 16.4739 37.2915 16.4739 36.5892C16.4739 35.8868 16.8704 35.3154 17.3578 35.3154C17.8451 35.3154 18.2416 35.8868 18.2416 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 36.5892C20.553 37.2915 20.1565 37.8629 19.6692 37.8629C19.1818 37.8629 18.7853 37.2915 18.7853 36.5892C18.7853 35.8868 19.1818 35.3154 19.6692 35.3154C20.1565 35.3154 20.553 35.8868 20.553 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 36.5892C25.1769 37.2915 24.7804 37.8629 24.2931 37.8629C23.8057 37.8629 23.4092 37.2915 23.4092 36.5892C23.4092 35.8868 23.8057 35.3154 24.2931 35.3154C24.7804 35.3154 25.1769 35.8868 25.1769 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 36.5892C29.8041 37.2915 29.4076 37.8629 28.9203 37.8629C28.4329 37.8629 28.0364 37.2915 28.0364 36.5892C28.0364 35.8868 28.4329 35.3154 28.9203 35.3154C29.4076 35.3154 29.8041 35.8868 29.8041 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 36.5892C32.1149 37.2915 31.7184 37.8629 31.231 37.8629C30.7437 37.8629 30.3472 37.2915 30.3472 36.5892C30.3472 35.8868 30.7437 35.3154 31.231 35.3154C31.7184 35.3154 32.1149 35.8868 32.1149 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0524 36.5892C39.0524 37.2915 38.6559 37.8629 38.1685 37.8629C37.6812 37.8629 37.2847 37.2915 37.2847 36.5892C37.2847 35.8868 37.6812 35.3154 38.1685 35.3154C38.6559 35.3154 39.0524 35.8868 39.0524 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 36.5892C48.3007 37.2915 47.9041 37.8629 47.4168 37.8629C46.9295 37.8629 46.533 37.2915 46.533 36.5892C46.533 35.8868 46.9295 35.3154 47.4168 35.3154C47.9041 35.3154 48.3007 35.8868 48.3007 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 36.5892C50.612 37.2915 50.2154 37.8629 49.7281 37.8629C49.2408 37.8629 48.8442 37.2915 48.8442 36.5892C48.8442 35.8868 49.2408 35.3154 49.7281 35.3154C50.2154 35.3154 50.612 35.8868 50.612 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5518 36.5892C57.5518 37.2915 57.1552 37.8629 56.6679 37.8629C56.1806 37.8629 55.7841 37.2915 55.7841 36.5892C55.7841 35.8868 56.1806 35.3154 56.6679 35.3154C57.1552 35.3154 57.5518 35.8868 57.5518 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8621 36.5892C59.8621 37.2915 59.4655 37.8629 58.9782 37.8629C58.4909 37.8629 58.0944 37.2915 58.0944 36.5892C58.0944 35.8868 58.4909 35.3154 58.9782 35.3154C59.4655 35.3154 59.8621 35.8868 59.8621 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 39.6976C15.9302 40.3999 15.5337 40.9713 15.0464 40.9713C14.559 40.9713 14.1625 40.3999 14.1625 39.6976C14.1625 38.9952 14.559 38.4238 15.0464 38.4238C15.5337 38.4238 15.9302 38.9952 15.9302 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2416 39.6976C18.2416 40.3999 17.8451 40.9713 17.3578 40.9713C16.8704 40.9713 16.4739 40.3999 16.4739 39.6976C16.4739 38.9952 16.8704 38.4238 17.3578 38.4238C17.8451 38.4238 18.2416 38.9952 18.2416 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 39.6976C20.553 40.3999 20.1565 40.9713 19.6692 40.9713C19.1818 40.9713 18.7853 40.3999 18.7853 39.6976C18.7853 38.9952 19.1818 38.4238 19.6692 38.4238C20.1565 38.4238 20.553 38.9952 20.553 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 39.6976C25.1769 40.3999 24.7804 40.9713 24.2931 40.9713C23.8057 40.9713 23.4092 40.3999 23.4092 39.6976C23.4092 38.9952 23.8057 38.4238 24.2931 38.4238C24.7804 38.4238 25.1769 38.9952 25.1769 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 39.6976C29.8041 40.3999 29.4076 40.9713 28.9203 40.9713C28.4329 40.9713 28.0364 40.3999 28.0364 39.6976C28.0364 38.9952 28.4329 38.4238 28.9203 38.4238C29.4076 38.4238 29.8041 38.9952 29.8041 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0524 39.6976C39.0524 40.3999 38.6559 40.9713 38.1685 40.9713C37.6812 40.9713 37.2847 40.3999 37.2847 39.6976C37.2847 38.9952 37.6812 38.4238 38.1685 38.4238C38.6559 38.4238 39.0524 38.9952 39.0524 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3655 39.6976C41.3655 40.3999 40.969 40.9713 40.4817 40.9713C39.9943 40.9713 39.5978 40.3999 39.5978 39.6976C39.5978 38.9952 39.9943 38.4238 40.4817 38.4238C40.969 38.4238 41.3655 38.9952 41.3655 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 39.6976C43.678 40.3999 43.2815 40.9713 42.7941 40.9713C42.3068 40.9713 41.9103 40.3999 41.9103 39.6976C41.9103 38.9952 42.3068 38.4238 42.7941 38.4238C43.2815 38.4238 43.678 38.9952 43.678 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 39.6976C48.3007 40.3999 47.9041 40.9713 47.4168 40.9713C46.9295 40.9713 46.533 40.3999 46.533 39.6976C46.533 38.9952 46.9295 38.4238 47.4168 38.4238C47.9041 38.4238 48.3007 38.9952 48.3007 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 39.6976C50.612 40.3999 50.2154 40.9713 49.7281 40.9713C49.2408 40.9713 48.8442 40.3999 48.8442 39.6976C48.8442 38.9952 49.2408 38.4238 49.7281 38.4238C50.2154 38.4238 50.612 38.9952 50.612 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5518 39.6976C57.5518 40.3999 57.1552 40.9713 56.6679 40.9713C56.1806 40.9713 55.7841 40.3999 55.7841 39.6976C55.7841 38.9952 56.1806 38.4238 56.6679 38.4238C57.1552 38.4238 57.5518 38.9952 57.5518 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8621 39.6976C59.8621 40.3999 59.4655 40.9713 58.9782 40.9713C58.4909 40.9713 58.0944 40.3999 58.0944 39.6976C58.0944 38.9952 58.4909 38.4238 58.9782 38.4238C59.4655 38.4238 59.8621 38.9952 59.8621 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 42.8059C15.9302 43.5083 15.5337 44.0797 15.0464 44.0797C14.559 44.0797 14.1625 43.5083 14.1625 42.8059C14.1625 42.1036 14.559 41.5322 15.0464 41.5322C15.5337 41.5322 15.9302 42.1036 15.9302 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2416 42.8059C18.2416 43.5083 17.8451 44.0797 17.3578 44.0797C16.8704 44.0797 16.4739 43.5083 16.4739 42.8059C16.4739 42.1036 16.8704 41.5322 17.3578 41.5322C17.8451 41.5322 18.2416 42.1036 18.2416 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 42.8059C20.553 43.5083 20.1565 44.0797 19.6692 44.0797C19.1818 44.0797 18.7853 43.5083 18.7853 42.8059C18.7853 42.1036 19.1818 41.5322 19.6692 41.5322C20.1565 41.5322 20.553 42.1036 20.553 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 42.8059C25.1769 43.5083 24.7804 44.0797 24.2931 44.0797C23.8057 44.0797 23.4092 43.5083 23.4092 42.8059C23.4092 42.1036 23.8057 41.5322 24.2931 41.5322C24.7804 41.5322 25.1769 42.1036 25.1769 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 42.8059C34.4274 43.5083 34.0309 44.0797 33.5435 44.0797C33.0562 44.0797 32.6597 43.5083 32.6597 42.8059C32.6597 42.1036 33.0562 41.5322 33.5435 41.5322C34.0309 41.5322 34.4274 42.1036 34.4274 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0524 42.8059C39.0524 43.5083 38.6559 44.0797 38.1685 44.0797C37.6812 44.0797 37.2847 43.5083 37.2847 42.8059C37.2847 42.1036 37.6812 41.5322 38.1685 41.5322C38.6559 41.5322 39.0524 42.1036 39.0524 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 42.8059C48.3007 43.5083 47.9041 44.0797 47.4168 44.0797C46.9295 44.0797 46.533 43.5083 46.533 42.8059C46.533 42.1036 46.9295 41.5322 47.4168 41.5322C47.9041 41.5322 48.3007 42.1036 48.3007 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 42.8059C50.612 43.5083 50.2154 44.0797 49.7281 44.0797C49.2408 44.0797 48.8442 43.5083 48.8442 42.8059C48.8442 42.1036 49.2408 41.5322 49.7281 41.5322C50.2154 41.5322 50.612 42.1036 50.612 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5518 42.8059C57.5518 43.5083 57.1552 44.0797 56.6679 44.0797C56.1806 44.0797 55.7841 43.5083 55.7841 42.8059C55.7841 42.1036 56.1806 41.5322 56.6679 41.5322C57.1552 41.5322 57.5518 42.1036 57.5518 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8621 42.8059C59.8621 43.5083 59.4655 44.0797 58.9782 44.0797C58.4909 44.0797 58.0944 43.5083 58.0944 42.8059C58.0944 42.1036 58.4909 41.5322 58.9782 41.5322C59.4655 41.5322 59.8621 42.1036 59.8621 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9302 45.9143C15.9302 46.6167 15.5337 47.1881 15.0464 47.1881C14.559 47.1881 14.1625 46.6167 14.1625 45.9143C14.1625 45.212 14.559 44.6406 15.0464 44.6406C15.5337 44.6406 15.9302 45.212 15.9302 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2416 45.9143C18.2416 46.6167 17.8451 47.1881 17.3578 47.1881C16.8704 47.1881 16.4739 46.6167 16.4739 45.9143C16.4739 45.212 16.8704 44.6406 17.3578 44.6406C17.8451 44.6406 18.2416 45.212 18.2416 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 45.9143C20.553 46.6167 20.1565 47.1881 19.6692 47.1881C19.1818 47.1881 18.7853 46.6167 18.7853 45.9143C18.7853 45.212 19.1818 44.6406 19.6692 44.6406C20.1565 44.6406 20.553 45.212 20.553 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 45.9143C25.1769 46.6167 24.7804 47.1881 24.2931 47.1881C23.8057 47.1881 23.4092 46.6167 23.4092 45.9143C23.4092 45.212 23.8057 44.6406 24.2931 44.6406C24.7804 44.6406 25.1769 45.212 25.1769 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 45.9143C32.1149 46.6167 31.7184 47.1881 31.231 47.1881C30.7437 47.1881 30.3472 46.6167 30.3472 45.9143C30.3472 45.212 30.7437 44.6406 31.231 44.6406C31.7184 44.6406 32.1149 45.212 32.1149 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 45.9143C34.4274 46.6167 34.0309 47.1881 33.5435 47.1881C33.0562 47.1881 32.6597 46.6167 32.6597 45.9143C32.6597 45.212 33.0562 44.6406 33.5435 44.6406C34.0309 44.6406 34.4274 45.212 34.4274 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0524 45.9143C39.0524 46.6167 38.6559 47.1881 38.1685 47.1881C37.6812 47.1881 37.2847 46.6167 37.2847 45.9143C37.2847 45.212 37.6812 44.6406 38.1685 44.6406C38.6559 44.6406 39.0524 45.212 39.0524 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3655 45.9143C41.3655 46.6167 40.969 47.1881 40.4817 47.1881C39.9943 47.1881 39.5978 46.6167 39.5978 45.9143C39.5978 45.212 39.9943 44.6406 40.4817 44.6406C40.969 44.6406 41.3655 45.212 41.3655 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 45.9143C43.678 46.6167 43.2815 47.1881 42.7941 47.1881C42.3068 47.1881 41.9103 46.6167 41.9103 45.9143C41.9103 45.212 42.3068 44.6406 42.7941 44.6406C43.2815 44.6406 43.678 45.212 43.678 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 45.9143C48.3007 46.6167 47.9041 47.1881 47.4168 47.1881C46.9295 47.1881 46.533 46.6167 46.533 45.9143C46.533 45.212 46.9295 44.6406 47.4168 44.6406C47.9041 44.6406 48.3007 45.212 48.3007 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 45.9143C50.612 46.6167 50.2154 47.1881 49.7281 47.1881C49.2408 47.1881 48.8442 46.6167 48.8442 45.9143C48.8442 45.212 49.2408 44.6406 49.7281 44.6406C50.2154 44.6406 50.612 45.212 50.612 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5518 45.9143C57.5518 46.6167 57.1552 47.1881 56.6679 47.1881C56.1806 47.1881 55.7841 46.6167 55.7841 45.9143C55.7841 45.212 56.1806 44.6406 56.6679 44.6406C57.1552 44.6406 57.5518 45.212 57.5518 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8621 45.9143C59.8621 46.6167 59.4655 47.1881 58.9782 47.1881C58.4909 47.1881 58.0944 46.6167 58.0944 45.9143C58.0944 45.212 58.4909 44.6406 58.9782 44.6406C59.4655 44.6406 59.8621 45.212 59.8621 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 49.0218C13.6196 49.7242 13.223 50.2955 12.7357 50.2955C12.2484 50.2955 11.8518 49.7242 11.8518 49.0218C11.8518 48.3194 12.2484 47.748 12.7357 47.748C13.223 47.748 13.6196 48.3194 13.6196 49.0218Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9857 50.2955C22.4738 50.2955 22.8696 49.7252 22.8696 49.0218C22.8696 48.3183 22.4738 47.748 21.9857 47.748C21.4975 47.748 21.1018 48.3183 21.1018 49.0218C21.1018 49.7252 21.4975 50.2955 21.9857 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1769 49.0218C25.1769 49.7242 24.7804 50.2955 24.2931 50.2955C23.8057 50.2955 23.4092 49.7242 23.4092 49.0218C23.4092 48.3194 23.8057 47.748 24.2931 47.748C24.7804 47.748 25.1769 48.3194 25.1769 49.0218Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1707 50.2955C38.6589 50.2955 39.0546 49.7252 39.0546 49.0218C39.0546 48.3183 38.6589 47.748 38.1707 47.748C37.6826 47.748 37.2869 48.3183 37.2869 49.0218C37.2869 49.7252 37.6826 50.2955 38.1707 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4817 50.2955C40.9698 50.2955 41.3655 49.7252 41.3655 49.0218C41.3655 48.3183 40.9698 47.748 40.4817 47.748C39.9935 47.748 39.5978 48.3183 39.5978 49.0218C39.5978 49.7252 39.9935 50.2955 40.4817 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 49.0218C43.678 49.7242 43.2815 50.2955 42.7941 50.2955C42.3068 50.2955 41.9103 49.7242 41.9103 49.0218C41.9103 48.3194 42.3068 47.748 42.7941 47.748C43.2815 47.748 43.678 48.3194 43.678 49.0218Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.106 50.2955C45.5942 50.2955 45.9899 49.7252 45.9899 49.0218C45.9899 48.3183 45.5942 47.748 45.106 47.748C44.6179 47.748 44.2222 48.3183 44.2222 49.0218C44.2222 49.7252 44.6179 50.2955 45.106 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2364 49.0218C55.2364 49.7242 54.8398 50.2955 54.3525 50.2955C53.8652 50.2955 53.4686 49.7242 53.4686 49.0218C53.4686 48.3194 53.8652 47.748 54.3525 47.748C54.8398 47.748 55.2364 48.3194 55.2364 49.0218Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6679 50.2955C57.1561 50.2955 57.5518 49.7252 57.5518 49.0218C57.5518 48.3183 57.1561 47.748 56.6679 47.748C56.1798 47.748 55.7841 48.3183 55.7841 49.0218C55.7841 49.7252 56.1798 50.2955 56.6679 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9782 50.2955C59.4664 50.2955 59.8621 49.7252 59.8621 49.0218C59.8621 48.3183 59.4664 47.748 58.9782 47.748C58.4901 47.748 58.0944 48.3183 58.0944 49.0218C58.0944 49.7252 58.4901 50.2955 58.9782 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.612 30.3743C50.612 31.0767 50.2154 31.648 49.7281 31.648C49.2408 31.648 48.8442 31.0767 48.8442 30.3743C48.8442 29.6719 49.2408 29.1006 49.7281 29.1006C50.2154 29.1006 50.612 29.6719 50.612 30.3743Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.044 31.648C52.5322 31.648 52.9279 31.0778 52.9279 30.3743C52.9279 29.6708 52.5322 29.1006 52.044 29.1006C51.5559 29.1006 51.1602 29.6708 51.1602 30.3743C51.1602 31.0778 51.5559 31.648 52.044 31.648Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 33.4827C48.3007 34.1851 47.9041 34.7564 47.4168 34.7564C46.9295 34.7564 46.533 34.1851 46.533 33.4827C46.533 32.7803 46.9295 32.209 47.4168 32.209C47.9041 32.209 48.3007 32.7803 48.3007 33.4827Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.044 34.7564C52.5322 34.7564 52.9279 34.1862 52.9279 33.4827C52.9279 32.7792 52.5322 32.209 52.044 32.209C51.5559 32.209 51.1602 32.7792 51.1602 33.4827C51.1602 34.1862 51.5559 34.7564 52.044 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6679 34.7564C57.1561 34.7564 57.5518 34.1862 57.5518 33.4827C57.5518 32.7792 57.1561 32.209 56.6679 32.209C56.1798 32.209 55.7841 32.7792 55.7841 33.4827C55.7841 34.1862 56.1798 34.7564 56.6679 34.7564Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 36.5892C34.4274 37.2915 34.0309 37.8629 33.5435 37.8629C33.0562 37.8629 32.6597 37.2915 32.6597 36.5892C32.6597 35.8868 33.0562 35.3154 33.5435 35.3154C34.0309 35.3154 34.4274 35.8868 34.4274 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 36.5892C43.678 37.2915 43.2815 37.8629 42.7941 37.8629C42.3068 37.8629 41.9103 37.2915 41.9103 36.5892C41.9103 35.8868 42.3068 35.3154 42.7941 35.3154C43.2815 35.3154 43.678 35.8868 43.678 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9235 36.5892C52.9235 37.2915 52.5269 37.8629 52.0396 37.8629C51.5523 37.8629 51.1558 37.2915 51.1558 36.5892C51.1558 35.8868 51.5523 35.3154 52.0396 35.3154C52.5269 35.3154 52.9235 35.8868 52.9235 36.5892Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 39.6976C32.1149 40.3999 31.7184 40.9713 31.231 40.9713C30.7437 40.9713 30.3472 40.3999 30.3472 39.6976C30.3472 38.9952 30.7437 38.4238 31.231 38.4238C31.7184 38.4238 32.1149 38.9952 32.1149 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 39.6976C34.4274 40.3999 34.0309 40.9713 33.5435 40.9713C33.0562 40.9713 32.6597 40.3999 32.6597 39.6976C32.6597 38.9952 33.0562 38.4238 33.5435 38.4238C34.0309 38.4238 34.4274 38.9952 34.4274 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9235 39.6976C52.9235 40.3999 52.5269 40.9713 52.0396 40.9713C51.5523 40.9713 51.1558 40.3999 51.1558 39.6976C51.1558 38.9952 51.5523 38.4238 52.0396 38.4238C52.5269 38.4238 52.9235 38.9952 52.9235 39.6976Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 42.8059C29.8041 43.5083 29.4076 44.0797 28.9203 44.0797C28.4329 44.0797 28.0364 43.5083 28.0364 42.8059C28.0364 42.1036 28.4329 41.5322 28.9203 41.5322C29.4076 41.5322 29.8041 42.1036 29.8041 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 42.8059C32.1149 43.5083 31.7184 44.0797 31.231 44.0797C30.7437 44.0797 30.3472 43.5083 30.3472 42.8059C30.3472 42.1036 30.7437 41.5322 31.231 41.5322C31.7184 41.5322 32.1149 42.1036 32.1149 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.678 42.8059C43.678 43.5083 43.2815 44.0797 42.7941 44.0797C42.3068 44.0797 41.9103 43.5083 41.9103 42.8059C41.9103 42.1036 42.3068 41.5322 42.7941 41.5322C43.2815 41.5322 43.678 42.1036 43.678 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9235 42.8059C52.9235 43.5083 52.5269 44.0797 52.0396 44.0797C51.5523 44.0797 51.1558 43.5083 51.1558 42.8059C51.1558 42.1036 51.5523 41.5322 52.0396 41.5322C52.5269 41.5322 52.9235 42.1036 52.9235 42.8059Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8041 45.9143C29.8041 46.6167 29.4076 47.1881 28.9203 47.1881C28.4329 47.1881 28.0364 46.6167 28.0364 45.9143C28.0364 45.212 28.4329 44.6406 28.9203 44.6406C29.4076 44.6406 29.8041 45.212 29.8041 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9235 45.9143C52.9235 46.6167 52.5269 47.1881 52.0396 47.1881C51.5523 47.1881 51.1558 46.6167 51.1558 45.9143C51.1558 45.212 51.5523 44.6406 52.0396 44.6406C52.5269 44.6406 52.9235 45.212 52.9235 45.9143Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6095 50.2955C27.0976 50.2955 27.4933 49.7252 27.4933 49.0218C27.4933 48.3183 27.0976 47.748 26.6095 47.748C26.1213 47.748 25.7256 48.3183 25.7256 49.0218C25.7256 49.7252 26.1213 50.2955 26.6095 50.2955Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7388 49.0218C36.7388 49.7242 36.3423 50.2955 35.8549 50.2955C35.3676 50.2955 34.9711 49.7242 34.9711 49.0218C34.9711 48.3194 35.3676 47.748 35.8549 47.748C36.3423 47.748 36.7388 48.3194 36.7388 49.0218Z",
    fill: "#8AD6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 27.2659C48.3007 27.9683 47.9041 28.5396 47.4168 28.5396C46.9295 28.5396 46.533 27.9683 46.533 27.2659C46.533 26.5635 46.9295 25.9922 47.4168 25.9922C47.9041 25.9922 48.3007 26.5635 48.3007 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6121 27.2659C50.6121 27.9683 50.2155 28.5396 49.7282 28.5396C49.2409 28.5396 48.8444 27.9683 48.8444 27.2659C48.8444 26.5635 49.2409 25.9922 49.7282 25.9922C50.2155 25.9922 50.6121 26.5635 50.6121 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.106 31.648C45.5942 31.648 45.9899 31.0778 45.9899 30.3743C45.9899 29.6708 45.5942 29.1006 45.106 29.1006C44.6179 29.1006 44.2222 29.6708 44.2222 30.3743C44.2222 31.0778 44.6179 31.648 45.106 31.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 30.3743C55.2365 31.0767 54.8399 31.648 54.3526 31.648C53.8653 31.648 53.4688 31.0767 53.4688 30.3743C53.4688 29.6719 53.8653 29.1006 54.3526 29.1006C54.8399 29.1006 55.2365 29.6719 55.2365 30.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.106 34.7564C45.5942 34.7564 45.9899 34.1862 45.9899 33.4827C45.9899 32.7792 45.5942 32.209 45.106 32.209C44.6179 32.209 44.2222 32.7792 44.2222 33.4827C44.2222 34.1862 44.6179 34.7564 45.106 34.7564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 33.4827C55.2365 34.1851 54.8399 34.7564 54.3526 34.7564C53.8653 34.7564 53.4688 34.1851 53.4688 33.4827C53.4688 32.7803 53.8653 32.209 54.3526 32.209C54.8399 32.209 55.2365 32.7803 55.2365 33.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4933 36.5892C27.4933 37.2915 27.0968 37.8629 26.6095 37.8629C26.1222 37.8629 25.7256 37.2915 25.7256 36.5892C25.7256 35.8868 26.1222 35.3154 26.6095 35.3154C27.0968 35.3154 27.4933 35.8868 27.4933 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9899 36.5892C45.9899 37.2915 45.5934 37.8629 45.106 37.8629C44.6187 37.8629 44.2222 37.2915 44.2222 36.5892C44.2222 35.8868 44.6187 35.3154 45.106 35.3154C45.5934 35.3154 45.9899 35.8868 45.9899 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 36.5892C55.2365 37.2915 54.8399 37.8629 54.3526 37.8629C53.8653 37.8629 53.4688 37.2915 53.4688 36.5892C53.4688 35.8868 53.8653 35.3154 54.3526 35.3154C54.8399 35.3154 55.2365 35.8868 55.2365 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4933 39.6976C27.4933 40.3999 27.0968 40.9713 26.6095 40.9713C26.1222 40.9713 25.7256 40.3999 25.7256 39.6976C25.7256 38.9952 26.1222 38.4238 26.6095 38.4238C27.0968 38.4238 27.4933 38.9952 27.4933 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 39.6976C36.7389 40.3999 36.3424 40.9713 35.8551 40.9713C35.3678 40.9713 34.9712 40.3999 34.9712 39.6976C34.9712 38.9952 35.3678 38.4238 35.8551 38.4238C36.3424 38.4238 36.7389 38.9952 36.7389 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9899 39.6976C45.9899 40.3999 45.5934 40.9713 45.106 40.9713C44.6187 40.9713 44.2222 40.3999 44.2222 39.6976C44.2222 38.9952 44.6187 38.4238 45.106 38.4238C45.5934 38.4238 45.9899 38.9952 45.9899 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 39.6976C55.2365 40.3999 54.8399 40.9713 54.3526 40.9713C53.8653 40.9713 53.4688 40.3999 53.4688 39.6976C53.4688 38.9952 53.8653 38.4238 54.3526 38.4238C54.8399 38.4238 55.2365 38.9952 55.2365 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4933 42.8059C27.4933 43.5083 27.0968 44.0797 26.6095 44.0797C26.1222 44.0797 25.7256 43.5083 25.7256 42.8059C25.7256 42.1036 26.1222 41.5322 26.6095 41.5322C27.0968 41.5322 27.4933 42.1036 27.4933 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 42.8059C36.7389 43.5083 36.3424 44.0797 35.8551 44.0797C35.3678 44.0797 34.9712 43.5083 34.9712 42.8059C34.9712 42.1036 35.3678 41.5322 35.8551 41.5322C36.3424 41.5322 36.7389 42.1036 36.7389 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9899 42.8059C45.9899 43.5083 45.5934 44.0797 45.106 44.0797C44.6187 44.0797 44.2222 43.5083 44.2222 42.8059C44.2222 42.1036 44.6187 41.5322 45.106 41.5322C45.5934 41.5322 45.9899 42.1036 45.9899 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 42.8059C55.2365 43.5083 54.8399 44.0797 54.3526 44.0797C53.8653 44.0797 53.4688 43.5083 53.4688 42.8059C53.4688 42.1036 53.8653 41.5322 54.3526 41.5322C54.8399 41.5322 55.2365 42.1036 55.2365 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 45.9143C36.7389 46.6167 36.3424 47.1881 35.8551 47.1881C35.3678 47.1881 34.9712 46.6167 34.9712 45.9143C34.9712 45.212 35.3678 44.6406 35.8551 44.6406C36.3424 44.6406 36.7389 45.212 36.7389 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9899 45.9143C45.9899 46.6167 45.5934 47.1881 45.106 47.1881C44.6187 47.1881 44.2222 46.6167 44.2222 45.9143C44.2222 45.212 44.6187 44.6406 45.106 44.6406C45.5934 44.6406 45.9899 45.212 45.9899 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 45.9143C55.2365 46.6167 54.8399 47.1881 54.3526 47.1881C53.8653 47.1881 53.4688 46.6167 53.4688 45.9143C53.4688 45.212 53.8653 44.6406 54.3526 44.6406C54.8399 44.6406 55.2365 45.212 55.2365 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3007 49.0218C48.3007 49.7242 47.9041 50.2955 47.4168 50.2955C46.9295 50.2955 46.533 49.7242 46.533 49.0218C46.533 48.3194 46.9295 47.748 47.4168 47.748C47.9041 47.748 48.3007 48.3194 48.3007 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6121 49.0218C50.6121 49.7242 50.2155 50.2955 49.7282 50.2955C49.2409 50.2955 48.8444 49.7242 48.8444 49.0218C48.8444 48.3194 49.2409 47.748 49.7282 47.748C50.2155 47.748 50.6121 48.3194 50.6121 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9304 27.2659C15.9304 27.9683 15.5338 28.5396 15.0465 28.5396C14.5592 28.5396 14.1626 27.9683 14.1626 27.2659C14.1626 26.5635 14.5592 25.9922 15.0465 25.9922C15.5338 25.9922 15.9304 26.5635 15.9304 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2418 27.2659C18.2418 27.9683 17.8452 28.5396 17.3579 28.5396C16.8706 28.5396 16.474 27.9683 16.474 27.2659C16.474 26.5635 16.8706 25.9922 17.3579 25.9922C17.8452 25.9922 18.2418 26.5635 18.2418 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 27.2659C20.553 27.9683 20.1565 28.5396 19.6692 28.5396C19.1818 28.5396 18.7853 27.9683 18.7853 27.2659C18.7853 26.5635 19.1818 25.9922 19.6692 25.9922C20.1565 25.9922 20.553 26.5635 20.553 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8043 27.2659C29.8043 27.9683 29.4077 28.5396 28.9204 28.5396C28.4331 28.5396 28.0365 27.9683 28.0365 27.2659C28.0365 26.5635 28.4331 25.9922 28.9204 25.9922C29.4077 25.9922 29.8043 26.5635 29.8043 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 27.2659C32.1149 27.9683 31.7184 28.5396 31.231 28.5396C30.7437 28.5396 30.3472 27.9683 30.3472 27.2659C30.3472 26.5635 30.7437 25.9922 31.231 25.9922C31.7184 25.9922 32.1149 26.5635 32.1149 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4274 27.2659C34.4274 27.9683 34.0309 28.5396 33.5435 28.5396C33.0562 28.5396 32.6597 27.9683 32.6597 27.2659C32.6597 26.5635 33.0562 25.9922 33.5435 25.9922C34.0309 25.9922 34.4274 26.5635 34.4274 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9235 27.2659C52.9235 27.9683 52.5269 28.5396 52.0396 28.5396C51.5523 28.5396 51.1558 27.9683 51.1558 27.2659C51.1558 26.5635 51.5523 25.9922 52.0396 25.9922C52.5269 25.9922 52.9235 26.5635 52.9235 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 27.2659C62.1746 27.9683 61.778 28.5396 61.2907 28.5396C60.8034 28.5396 60.4069 27.9683 60.4069 27.2659C60.4069 26.5635 60.8034 25.9922 61.2907 25.9922C61.778 25.9922 62.1746 26.5635 62.1746 27.2659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 30.3743C13.6196 31.0767 13.223 31.648 12.7357 31.648C12.2484 31.648 11.8518 31.0767 11.8518 30.3743C11.8518 29.6719 12.2484 29.1006 12.7357 29.1006C13.223 29.1006 13.6196 29.6719 13.6196 30.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9857 31.648C22.4738 31.648 22.8696 31.0778 22.8696 30.3743C22.8696 29.6708 22.4738 29.1006 21.9857 29.1006C21.4975 29.1006 21.1018 29.6708 21.1018 30.3743C21.1018 31.0778 21.4975 31.648 21.9857 31.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6095 31.648C27.0976 31.648 27.4933 31.0778 27.4933 30.3743C27.4933 29.6708 27.0976 29.1006 26.6095 29.1006C26.1213 29.1006 25.7256 29.6708 25.7256 30.3743C25.7256 31.0778 26.1213 31.648 26.6095 31.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 30.3743C36.7389 31.0767 36.3424 31.648 35.8551 31.648C35.3678 31.648 34.9712 31.0767 34.9712 30.3743C34.9712 29.6719 35.3678 29.1006 35.8551 29.1006C36.3424 29.1006 36.7389 29.6719 36.7389 30.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9782 31.648C59.4664 31.648 59.8621 31.0778 59.8621 30.3743C59.8621 29.6708 59.4664 29.1006 58.9782 29.1006C58.4901 29.1006 58.0944 29.6708 58.0944 30.3743C58.0944 31.0778 58.4901 31.648 58.9782 31.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 30.3743C62.1746 31.0767 61.778 31.648 61.2907 31.648C60.8034 31.648 60.4069 31.0767 60.4069 30.3743C60.4069 29.6719 60.8034 29.1006 61.2907 29.1006C61.778 29.1006 62.1746 29.6719 62.1746 30.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 33.4827C13.6196 34.1851 13.223 34.7564 12.7357 34.7564C12.2484 34.7564 11.8518 34.1851 11.8518 33.4827C11.8518 32.7803 12.2484 32.209 12.7357 32.209C13.223 32.209 13.6196 32.7803 13.6196 33.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9857 34.7564C22.4738 34.7564 22.8696 34.1862 22.8696 33.4827C22.8696 32.7792 22.4738 32.209 21.9857 32.209C21.4975 32.209 21.1018 32.7792 21.1018 33.4827C21.1018 34.1862 21.4975 34.7564 21.9857 34.7564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6095 34.7564C27.0976 34.7564 27.4933 34.1862 27.4933 33.4827C27.4933 32.7792 27.0976 32.209 26.6095 32.209C26.1213 32.209 25.7256 32.7792 25.7256 33.4827C25.7256 34.1862 26.1213 34.7564 26.6095 34.7564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 33.4827C36.7389 34.1851 36.3424 34.7564 35.8551 34.7564C35.3678 34.7564 34.9712 34.1851 34.9712 33.4827C34.9712 32.7803 35.3678 32.209 35.8551 32.209C36.3424 32.209 36.7389 32.7803 36.7389 33.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 33.4827C62.1746 34.1851 61.778 34.7564 61.2907 34.7564C60.8034 34.7564 60.4069 34.1851 60.4069 33.4827C60.4069 32.7803 60.8034 32.209 61.2907 32.209C61.778 32.209 62.1746 32.7803 62.1746 33.4827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 36.5892C13.6196 37.2915 13.223 37.8629 12.7357 37.8629C12.2484 37.8629 11.8518 37.2915 11.8518 36.5892C11.8518 35.8868 12.2484 35.3154 12.7357 35.3154C13.223 35.3154 13.6196 35.8868 13.6196 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 36.5892C22.8655 37.2915 22.469 37.8629 21.9817 37.8629C21.4943 37.8629 21.0978 37.2915 21.0978 36.5892C21.0978 35.8868 21.4943 35.3154 21.9817 35.3154C22.469 35.3154 22.8655 35.8868 22.8655 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7389 36.5892C36.7389 37.2915 36.3424 37.8629 35.8551 37.8629C35.3678 37.8629 34.9712 37.2915 34.9712 36.5892C34.9712 35.8868 35.3678 35.3154 35.8551 35.3154C36.3424 35.3154 36.7389 35.8868 36.7389 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3655 36.5892C41.3655 37.2915 40.969 37.8629 40.4817 37.8629C39.9943 37.8629 39.5978 37.2915 39.5978 36.5892C39.5978 35.8868 39.9943 35.3154 40.4817 35.3154C40.969 35.3154 41.3655 35.8868 41.3655 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 36.5892C62.1746 37.2915 61.778 37.8629 61.2907 37.8629C60.8034 37.8629 60.4069 37.2915 60.4069 36.5892C60.4069 35.8868 60.8034 35.3154 61.2907 35.3154C61.778 35.3154 62.1746 35.8868 62.1746 36.5892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 39.6976C13.6196 40.3999 13.223 40.9713 12.7357 40.9713C12.2484 40.9713 11.8518 40.3999 11.8518 39.6976C11.8518 38.9952 12.2484 38.4238 12.7357 38.4238C13.223 38.4238 13.6196 38.9952 13.6196 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 39.6976C22.8655 40.3999 22.469 40.9713 21.9817 40.9713C21.4943 40.9713 21.0978 40.3999 21.0978 39.6976C21.0978 38.9952 21.4943 38.4238 21.9817 38.4238C22.469 38.4238 22.8655 38.9952 22.8655 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 39.6976C62.1746 40.3999 61.778 40.9713 61.2907 40.9713C60.8034 40.9713 60.4069 40.3999 60.4069 39.6976C60.4069 38.9952 60.8034 38.4238 61.2907 38.4238C61.778 38.4238 62.1746 38.9952 62.1746 39.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 42.8059C13.6196 43.5083 13.223 44.0797 12.7357 44.0797C12.2484 44.0797 11.8518 43.5083 11.8518 42.8059C11.8518 42.1036 12.2484 41.5322 12.7357 41.5322C13.223 41.5322 13.6196 42.1036 13.6196 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 42.8059C22.8655 43.5083 22.469 44.0797 21.9817 44.0797C21.4943 44.0797 21.0978 43.5083 21.0978 42.8059C21.0978 42.1036 21.4943 41.5322 21.9817 41.5322C22.469 41.5322 22.8655 42.1036 22.8655 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3655 42.8059C41.3655 43.5083 40.969 44.0797 40.4817 44.0797C39.9943 44.0797 39.5978 43.5083 39.5978 42.8059C39.5978 42.1036 39.9943 41.5322 40.4817 41.5322C40.969 41.5322 41.3655 42.1036 41.3655 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 42.8059C62.1746 43.5083 61.778 44.0797 61.2907 44.0797C60.8034 44.0797 60.4069 43.5083 60.4069 42.8059C60.4069 42.1036 60.8034 41.5322 61.2907 41.5322C61.778 41.5322 62.1746 42.1036 62.1746 42.8059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6196 45.9143C13.6196 46.6167 13.223 47.1881 12.7357 47.1881C12.2484 47.1881 11.8518 46.6167 11.8518 45.9143C11.8518 45.212 12.2484 44.6406 12.7357 44.6406C13.223 44.6406 13.6196 45.212 13.6196 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8655 45.9143C22.8655 46.6167 22.469 47.1881 21.9817 47.1881C21.4943 47.1881 21.0978 46.6167 21.0978 45.9143C21.0978 45.212 21.4943 44.6406 21.9817 44.6406C22.469 44.6406 22.8655 45.212 22.8655 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4933 45.9143C27.4933 46.6167 27.0968 47.1881 26.6095 47.1881C26.1222 47.1881 25.7256 46.6167 25.7256 45.9143C25.7256 45.212 26.1222 44.6406 26.6095 44.6406C27.0968 44.6406 27.4933 45.212 27.4933 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 45.9143C62.1746 46.6167 61.778 47.1881 61.2907 47.1881C60.8034 47.1881 60.4069 46.6167 60.4069 45.9143C60.4069 45.212 60.8034 44.6406 61.2907 44.6406C61.778 44.6406 62.1746 45.212 62.1746 45.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9304 49.0218C15.9304 49.7242 15.5338 50.2955 15.0465 50.2955C14.5592 50.2955 14.1626 49.7242 14.1626 49.0218C14.1626 48.3194 14.5592 47.748 15.0465 47.748C15.5338 47.748 15.9304 48.3194 15.9304 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3579 50.2955C17.846 50.2955 18.2418 49.7252 18.2418 49.0218C18.2418 48.3183 17.846 47.748 17.3579 47.748C16.8697 47.748 16.474 48.3183 16.474 49.0218C16.474 49.7252 16.8697 50.2955 17.3579 50.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.553 49.0218C20.553 49.7242 20.1565 50.2955 19.6692 50.2955C19.1818 50.2955 18.7853 49.7242 18.7853 49.0218C18.7853 48.3194 19.1818 47.748 19.6692 47.748C20.1565 47.748 20.553 48.3194 20.553 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8043 49.0218C29.8043 49.7242 29.4077 50.2955 28.9204 50.2955C28.4331 50.2955 28.0365 49.7242 28.0365 49.0218C28.0365 48.3194 28.4331 47.748 28.9204 47.748C29.4077 47.748 29.8043 48.3194 29.8043 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.231 50.2955C31.7192 50.2955 32.1149 49.7252 32.1149 49.0218C32.1149 48.3183 31.7192 47.748 31.231 47.748C30.7429 47.748 30.3472 48.3183 30.3472 49.0218C30.3472 49.7252 30.7429 50.2955 31.231 50.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5435 50.2955C34.0317 50.2955 34.4274 49.7252 34.4274 49.0218C34.4274 48.3183 34.0317 47.748 33.5435 47.748C33.0554 47.748 32.6597 48.3183 32.6597 49.0218C32.6597 49.7252 33.0554 50.2955 33.5435 50.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.044 50.2955C52.5322 50.2955 52.9279 49.7252 52.9279 49.0218C52.9279 48.3183 52.5322 47.748 52.044 47.748C51.5559 47.748 51.1602 48.3183 51.1602 49.0218C51.1602 49.7252 51.5559 50.2955 52.044 50.2955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1746 49.0218C62.1746 49.7242 61.778 50.2955 61.2907 50.2955C60.8034 50.2955 60.4069 49.7242 60.4069 49.0218C60.4069 48.3194 60.8034 47.748 61.2907 47.748C61.778 47.748 62.1746 48.3194 62.1746 49.0218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.874 -12.6318V27.1973C268.874 28.2859 267.991 29.1696 266.902 29.1696C265.813 29.1696 264.93 28.2859 264.93 27.1973V-12.6318H268.874Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.789 -12.6318V27.1973C333.789 28.2859 332.905 29.1696 331.816 29.1696C330.728 29.1696 329.844 28.2859 329.844 27.1973V-12.6318H333.789Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.658 21.4189H254.99C250.681 21.4189 247.188 24.912 247.188 29.2208V47.2739C247.188 51.5828 250.681 55.0758 254.99 55.0758H334.658C338.967 55.0758 342.46 51.5828 342.46 47.2739V29.2208C342.46 24.912 338.967 21.4189 334.658 21.4189Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.323 22.8271H259.658C256.127 22.8271 253.264 25.6899 253.264 29.2212V47.2743C253.264 50.8056 256.127 53.6683 259.658 53.6683H339.323C342.855 53.6683 345.717 50.8056 345.717 47.2743V29.2212C345.717 25.6899 342.855 22.8271 339.323 22.8271Z",
    fill: "white",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.326 24.2356C342.075 24.2356 344.309 26.47 344.309 29.2184V47.2749C344.309 50.0234 342.075 52.2578 339.326 52.2578H259.658C256.909 52.2578 254.675 50.0234 254.675 47.2749V29.2184C254.675 26.47 256.909 24.2356 259.658 24.2356H339.326ZM339.326 21.4199H259.658C255.35 21.4199 251.856 24.9109 251.856 29.2218V47.2783C251.856 51.5858 255.347 55.0801 259.658 55.0801H339.326C343.634 55.0801 347.128 51.5891 347.128 47.2783V29.2218C347.128 24.9143 343.637 21.4199 339.326 21.4199Z",
    fill: "#9EADC0",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.498 47.634C288.031 47.634 287.651 47.2544 287.651 46.7873V30.1924C287.651 29.7254 288.031 29.3457 288.498 29.3457C288.965 29.3457 289.345 29.7254 289.345 30.1924V46.7873C289.345 47.2544 288.965 47.634 288.498 47.634Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.286 46.9488H267.777L265.136 45.3663L267.777 43.7871H283.286V46.9488Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.337 33.0012H299.192C298.412 33.0012 297.784 32.3695 297.784 31.5934C297.784 30.8172 298.416 30.1855 299.192 30.1855H310.337C311.116 30.1855 311.745 30.8172 311.745 31.5934C311.745 32.3695 311.113 33.0012 310.337 33.0012Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.195 37.8137H294.82C294.04 37.8137 293.412 37.182 293.412 36.4059C293.412 35.6297 294.044 34.998 294.82 34.998H326.195C326.975 34.998 327.603 35.6297 327.603 36.4059C327.603 37.182 326.971 37.8137 326.195 37.8137Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.795 42.6203H294.82C294.04 42.6203 293.412 41.9887 293.412 41.2125C293.412 40.4364 294.044 39.8047 294.82 39.8047H309.795C310.575 39.8047 311.203 40.4364 311.203 41.2125C311.203 41.9887 310.571 42.6203 309.795 42.6203Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.596 47.428H294.82C294.04 47.428 293.412 46.7963 293.412 46.0201C293.412 45.244 294.044 44.6123 294.82 44.6123H316.596C317.375 44.6123 318.004 45.244 318.004 46.0201C318.004 46.7963 317.372 47.428 316.596 47.428Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.406 31.5933C296.406 32.4165 295.697 33.085 294.82 33.085C293.943 33.085 293.234 32.4165 293.234 31.5933C293.234 30.7702 293.943 30.1016 294.82 30.1016C295.697 30.1016 296.406 30.7702 296.406 31.5933Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.987 33.0012H321.241C320.461 33.0012 319.833 32.3695 319.833 31.5934C319.833 30.8172 320.464 30.1855 321.241 30.1855H337.987C338.766 30.1855 339.395 30.8172 339.395 31.5934C339.395 32.3695 338.763 33.0012 337.987 33.0012Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.458 31.5933C318.458 32.4165 317.749 33.085 316.872 33.085C315.995 33.085 315.286 32.4165 315.286 31.5933C315.286 30.7702 315.995 30.1016 316.872 30.1016C317.749 30.1016 318.458 30.7702 318.458 31.5933Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.384 42.6203H321.638C320.859 42.6203 320.23 41.9887 320.23 41.2125C320.23 40.4364 320.862 39.8047 321.638 39.8047H338.384C339.164 39.8047 339.792 40.4364 339.792 41.2125C339.792 41.9887 339.16 42.6203 338.384 42.6203Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.852 41.2115C318.852 42.0346 318.143 42.7032 317.266 42.7032C316.39 42.7032 315.681 42.0346 315.681 41.2115C315.681 40.3883 316.39 39.7197 317.266 39.7197C318.143 39.7197 318.852 40.3883 318.852 41.2115Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.34 47.428H327.195C326.415 47.428 325.787 46.7963 325.787 46.0201C325.787 45.244 326.419 44.6123 327.195 44.6123H338.34C339.119 44.6123 339.748 45.244 339.748 46.0201C339.748 46.7963 339.116 47.428 338.34 47.428Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.413 46.0162C324.413 46.8393 323.704 47.5079 322.827 47.5079C321.95 47.5079 321.241 46.8393 321.241 46.0162C321.241 45.193 321.95 44.5244 322.827 44.5244C323.704 44.5244 324.413 45.193 324.413 46.0162Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.404 37.8927C334.28 37.8927 334.99 37.2248 334.99 36.4009C334.99 35.5771 334.28 34.9092 333.404 34.9092C332.528 34.9092 331.818 35.5771 331.818 36.4009C331.818 37.2248 332.528 37.8927 333.404 37.8927Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.286 30.1152H265.136V39.8961H283.286V30.1152Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.486 -12.6318V27.1973C872.486 28.2859 871.602 29.1696 870.513 29.1696C869.425 29.1696 868.541 28.2859 868.541 27.1973V-12.6318H872.486Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.402 -12.6318V27.1973C937.402 28.2859 936.518 29.1696 935.43 29.1696C934.341 29.1696 933.458 28.2859 933.458 27.1973V-12.6318H937.402Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.601 21.4189H938.269C942.573 21.4189 946.071 24.9133 946.071 29.2208V47.2773C946.071 51.5814 942.576 55.0792 938.269 55.0792H858.601C854.297 55.0792 850.799 51.5848 850.799 47.2773V29.2208C850.799 24.9167 854.293 21.4189 858.601 21.4189Z",
    fill: "#CBB4B2",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.937 22.8262H863.272C859.741 22.8262 856.878 25.6889 856.878 29.2202V47.2733C856.878 50.8047 859.741 53.6674 863.272 53.6674H942.937C946.468 53.6674 949.331 50.8047 949.331 47.2733V29.2202C949.331 25.6889 946.468 22.8262 942.937 22.8262Z",
    fill: "white",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.941 24.2346C945.689 24.2346 947.924 26.469 947.924 29.2174V47.2739C947.924 50.0224 945.689 52.2568 942.941 52.2568H863.273C860.524 52.2568 858.29 50.0224 858.29 47.2739V29.2174C858.29 26.469 860.524 24.2346 863.273 24.2346H942.941ZM942.941 21.4189H863.273C858.965 21.4189 855.471 24.91 855.471 29.2208V47.2773C855.471 51.5848 858.962 55.0792 863.273 55.0792H942.941C947.248 55.0792 950.743 51.5882 950.743 47.2773V29.2208C950.743 24.9133 947.252 21.4189 942.941 21.4189Z",
    fill: "#9EADC0",
    stroke: "#232222",
    strokeWidth: 0.578265
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.11 47.634C891.643 47.634 891.263 47.2544 891.263 46.7873V30.1924C891.263 29.7254 891.643 29.3457 892.11 29.3457C892.577 29.3457 892.957 29.7254 892.957 30.1924V46.7873C892.957 47.2544 892.577 47.634 892.11 47.634Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.899 46.9498H871.39L868.749 45.3673L871.39 43.7881H886.899V46.9498Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.95 33.0012H902.805C902.026 33.0012 901.397 32.3695 901.397 31.5934C901.397 30.8172 902.029 30.1855 902.805 30.1855H913.95C914.73 30.1855 915.358 30.8172 915.358 31.5934C915.358 32.3695 914.726 33.0012 913.95 33.0012Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.808 37.8127H898.433C897.653 37.8127 897.025 37.1811 897.025 36.4049C897.025 35.6287 897.657 34.9971 898.433 34.9971H929.808C930.588 34.9971 931.216 35.6287 931.216 36.4049C931.216 37.1811 930.585 37.8127 929.808 37.8127Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.408 42.6213H898.433C897.653 42.6213 897.025 41.9896 897.025 41.2135C897.025 40.4373 897.657 39.8057 898.433 39.8057H913.408C914.188 39.8057 914.816 40.4373 914.816 41.2135C914.816 41.9896 914.185 42.6213 913.408 42.6213Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.209 47.4289H898.437C897.657 47.4289 897.029 46.7973 897.029 46.0211C897.029 45.245 897.661 44.6133 898.437 44.6133H920.209C920.989 44.6133 921.617 45.245 921.617 46.0211C921.617 46.7973 920.986 47.4289 920.209 47.4289Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.019 31.5933C900.019 32.4165 899.31 33.085 898.433 33.085C897.557 33.085 896.848 32.4165 896.848 31.5933C896.848 30.7702 897.557 30.1016 898.433 30.1016C899.31 30.1016 900.019 30.7702 900.019 31.5933Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.6 33.0012H924.854C924.074 33.0012 923.446 32.3695 923.446 31.5934C923.446 30.8172 924.077 30.1855 924.854 30.1855H941.6C942.379 30.1855 943.008 30.8172 943.008 31.5934C943.008 32.3695 942.376 33.0012 941.6 33.0012Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.069 31.5933C922.069 32.4165 921.36 33.085 920.483 33.085C919.606 33.085 918.897 32.4165 918.897 31.5933C918.897 30.7702 919.606 30.1016 920.483 30.1016C921.36 30.1016 922.069 30.7702 922.069 31.5933Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.996 42.6213H925.25C924.471 42.6213 923.842 41.9896 923.842 41.2135C923.842 40.4373 924.474 39.8057 925.25 39.8057H941.996C942.776 39.8057 943.404 40.4373 943.404 41.2135C943.404 41.9896 942.772 42.6213 941.996 42.6213Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.464 41.2115C922.464 42.0346 921.755 42.7032 920.879 42.7032C920.002 42.7032 919.293 42.0346 919.293 41.2115C919.293 40.3883 920.002 39.7197 920.879 39.7197C921.755 39.7197 922.464 40.3883 922.464 41.2115Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.952 47.4289H930.807C930.028 47.4289 929.399 46.7973 929.399 46.0211C929.399 45.245 930.031 44.6133 930.807 44.6133H941.952C942.732 44.6133 943.36 45.245 943.36 46.0211C943.36 46.7973 942.728 47.4289 941.952 47.4289Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.022 46.0162C928.022 46.8393 927.313 47.5079 926.436 47.5079C925.559 47.5079 924.85 46.8393 924.85 46.0162C924.85 45.193 925.559 44.5244 926.436 44.5244C927.313 44.5244 928.022 45.193 928.022 46.0162Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.603 36.4029C938.603 37.226 937.894 37.8946 937.017 37.8946C936.14 37.8946 935.431 37.226 935.431 36.4029C935.431 35.5797 936.14 34.9111 937.017 34.9111C937.894 34.9111 938.603 35.5797 938.603 36.4029Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.899 30.1152H868.749V39.8961H886.899V30.1152Z",
    fill: "#9EADC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-26.9609 241V-6.68819L1088 -7.06348V241H-26.9609Z",
    fill: "url(#paint37_linear_1081_118500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1081_118500",
    x1: 97.8215,
    y1: -571,
    x2: 1185.32,
    y2: -83.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF9FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1081_118500",
    x1: 788.811,
    y1: 141.939,
    x2: 782.234,
    y2: 116.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1081_118500",
    x1: 841.505,
    y1: 109.317,
    x2: 841.505,
    y2: 173.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1081_118500",
    x1: 824.219,
    y1: 175.896,
    x2: 835.807,
    y2: 108.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1081_118500",
    x1: 824.219,
    y1: 175.896,
    x2: 835.807,
    y2: 108.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1081_118500",
    x1: 957.426,
    y1: 175.896,
    x2: 969.014,
    y2: 108.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1081_118500",
    x1: 957.426,
    y1: 175.896,
    x2: 969.014,
    y2: 108.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1081_118500",
    x1: 957.426,
    y1: 175.896,
    x2: 969.014,
    y2: 108.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1081_118500",
    x1: 892.589,
    y1: 149.295,
    x2: 895.997,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1081_118500",
    x1: 892.589,
    y1: 149.295,
    x2: 895.997,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1081_118500",
    x1: 892.589,
    y1: 149.295,
    x2: 895.997,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1081_118500",
    x1: 892.589,
    y1: 149.295,
    x2: 895.997,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1081_118500",
    x1: 1025.8,
    y1: 149.295,
    x2: 1029.21,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1081_118500",
    x1: 1025.8,
    y1: 149.295,
    x2: 1029.21,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1081_118500",
    x1: 1025.8,
    y1: 149.295,
    x2: 1029.21,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1081_118500",
    x1: 1025.8,
    y1: 149.295,
    x2: 1029.21,
    y2: 114.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1081_118500",
    x1: 752.737,
    y1: 135.308,
    x2: 738.645,
    y2: 120.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ECD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1081_118500",
    x1: 747.429,
    y1: 143.324,
    x2: 757.335,
    y2: 113.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1081_118500",
    x1: 306.894,
    y1: 192.003,
    x2: 313.471,
    y2: 166.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1081_118500",
    x1: 254.2,
    y1: 159.381,
    x2: 254.2,
    y2: 223.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EEDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0E3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1081_118500",
    x1: 271.486,
    y1: 225.959,
    x2: 259.898,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1081_118500",
    x1: 271.486,
    y1: 225.959,
    x2: 259.898,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1081_118500",
    x1: 138.279,
    y1: 225.959,
    x2: 126.691,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1081_118500",
    x1: 138.279,
    y1: 225.959,
    x2: 126.691,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1081_118500",
    x1: 138.279,
    y1: 225.959,
    x2: 126.691,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1081_118500",
    x1: 5.07327,
    y1: 225.959,
    x2: -6.51473,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1081_118500",
    x1: 5.07327,
    y1: 225.959,
    x2: -6.51473,
    y2: 158.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1081_118500",
    x1: 203.116,
    y1: 199.36,
    x2: 199.708,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1081_118500",
    x1: 203.116,
    y1: 199.36,
    x2: 199.708,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1081_118500",
    x1: 203.116,
    y1: 199.36,
    x2: 199.708,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1081_118500",
    x1: 203.116,
    y1: 199.36,
    x2: 199.708,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1081_118500",
    x1: 69.9083,
    y1: 199.36,
    x2: 66.5001,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1081_118500",
    x1: 69.9083,
    y1: 199.36,
    x2: 66.5001,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1081_118500",
    x1: 69.9083,
    y1: 199.36,
    x2: 66.5001,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1081_118500",
    x1: 69.9083,
    y1: 199.36,
    x2: 66.5001,
    y2: 164.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1081_118500",
    x1: 342.968,
    y1: 185.371,
    x2: 357.061,
    y2: 170.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3F0F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9ECD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1081_118500",
    x1: 348.276,
    y1: 193.387,
    x2: 338.37,
    y2: 163.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1081_118500",
    x1: 18.3054,
    y1: 22.2495,
    x2: 93.4513,
    y2: 426.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727BBA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1081_118500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 229,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1081_118500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 585.284,
    height: 84.53,
    fill: "white",
    transform: "translate(726.538 97.5088)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1081_118500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 585.284,
    height: 84.53,
    fill: "white",
    transform: "matrix(-1 0 0 1 369.167 147.574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndergroundBgTablet);
export default __webpack_public_path__ + "static/media/UndergroundBgTablet.35c4f94c05469de4fcf0.svg";
export { ForwardRef as ReactComponent };